"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[890],{

/***/ 43723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95576);
/* harmony import */ var _components_icons_BookmarkIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2409);




var BookmarkButtonIcon = function(param) {
    var onClick = param.onClick, bookmarked = param.bookmarked, _bookmarkedColor = param.bookmarkedColor, bookmarkedColor = _bookmarkedColor === void 0 ? _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .primary */ .T$ : _bookmarkedColor, _bookmarkedStrokeColor = param.bookmarkedStrokeColor, bookmarkedStrokeColor = _bookmarkedStrokeColor === void 0 ? _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .primary */ .T$ : _bookmarkedStrokeColor;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("button", {
        type: "button",
        onClick: onClick,
        css: {
            border: 0,
            background: "none",
            padding: 0,
            display: "inline-flex",
            outline: "none",
            cursor: "pointer",
            height: 18
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_icons_BookmarkIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            fill: bookmarked ? bookmarkedColor : undefined,
            stroke: bookmarked ? bookmarkedStrokeColor : undefined
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BookmarkButtonIcon);


/***/ }),

/***/ 93742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ feed_FeedItem; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./lib/mutations/ToggleBookmark.tsx
var ToggleBookmark = __webpack_require__(96495);
// EXTERNAL MODULE: ./lib/mutations/ToggleUpvote.tsx
var ToggleUpvote = __webpack_require__(97511);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
;// CONCATENATED MODULE: ./components/user/utils/isAdmin.ts
function isAdmin(user) {
    if (!user) {
        return false;
    }
    if (user.isSiteAdmin || user.isLimitedSiteAdmin) {
        return true;
    }
    if (user.__typename === "GovernmentUser" && user.government) {
        return user.government.slug === "govtopia";
    }
    return !user || (user.email || "").indexOf("@govlaunch.com") !== -1;
};

// EXTERNAL MODULE: ./components/feed/card/FeedAuthorPicture.tsx
var FeedAuthorPicture = __webpack_require__(7853);
// EXTERNAL MODULE: ./components/feed/card/FeedCard.tsx
var FeedCard = __webpack_require__(35321);
// EXTERNAL MODULE: ./components/feed/card/FeedCardActions.tsx + 1 modules
var FeedCardActions = __webpack_require__(95896);
// EXTERNAL MODULE: ./components/feed/card/FeedCardPitch.tsx
var FeedCardPitch = __webpack_require__(44087);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./components/feed/ProjectFeed.tsx


















var ProjectFeed = function(param) {
    var project = param.project, context = param.context, createdAt = param.createdAt;
    var viewer = (0,Auth/* useSelfie */.yD)();
    var author = project.author;
    var projectLink = getProjectLink(project);
    var isAdminAuthor = isAdmin(author);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeedCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: {
                    opacity: project.viewerCanRead ? 1 : 0.5
                }
            }, bind), {
                children: [
                    viewer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleUpvote/* default */.Z, {
                        viewer: viewer,
                        upvotesCount: project.upvotesCount || 0,
                        viewerDidUpvote: project.viewerDidUpvote || false,
                        targetType: "PROJECT",
                        targetId: project._id,
                        children: function(param) {
                            var toggleUpvote = param.toggle;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleBookmark/* default */.Z, {
                                targetId: project._id,
                                targetType: "PROJECT",
                                viewerDidBookmark: project.viewerDidBookmark || false,
                                children: function(param) {
                                    var toggleBookmark = param.toggle;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedCardActions/* default */.Z, {
                                        isShowing: hovered,
                                        viewerDidUpvote: project.viewerDidUpvote || false,
                                        onUpvote: toggleUpvote,
                                        viewerDidBookmark: project.viewerDidBookmark || false,
                                        onBookmark: toggleBookmark,
                                        link: projectLink,
                                        viewerCanEdit: project.viewerCanEdit || false,
                                        editLink: getEditProjectLink(project),
                                        viewerDidComment: project.viewerDidComment || false
                                    });
                                }
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedAuthorPicture/* default */.Z, {
                                author: author,
                                vendor: project.__typename === "VendorProject" ? project.vendor : null,
                                government: project.__typename === "GovernmentProject" ? project.government : null,
                                group: project.__typename === "GroupProject" ? project.group : null,
                                gatedAuthor: isAdminAuthor,
                                context: context
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                ml: 10,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedCardPitch/* default */.Z, {
                                        author: author,
                                        gatedAuthor: isAdminAuthor,
                                        government: project.__typename === "GovernmentProject" ? project.government : null,
                                        vendor: project.__typename === "VendorProject" ? project.vendor : null,
                                        action: intl.formatMessage({
                                            id: "uxICV0",
                                            defaultMessage: "shared a"
                                        }),
                                        target: intl.formatMessage({
                                            defaultMessage: "project",
                                            id: "RbFAl7"
                                        }),
                                        targetLink: projectLink,
                                        date: createdAt
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 9,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                fontSize: 15,
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, projectLink), {
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                        css: {
                                                            color: palette/* darkGray */.O5,
                                                            fontWeight: "bold",
                                                            wordBreak: "break-word",
                                                            ":hover": {
                                                                textDecoration: "underline !important"
                                                            }
                                                        },
                                                        children: project.title
                                                    })
                                                })),
                                                !isAdminAuthor && project.__typename === "GovernmentProject" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        marginTop: 4
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "in <location></location>",
                                                        id: "atBiSP",
                                                        values: {
                                                            // eslint-disable-next-line react/display-name
                                                            location: function() {
                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                    href: "/government?governmentSlug=".concat(project.government.slug),
                                                                    as: "/governments/".concat(project.government.slug),
                                                                    passHref: true,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                                        css: {
                                                                            color: palette/* mediumGray */.rF,
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            ":hover": {
                                                                                textDecoration: "underline !important"
                                                                            }
                                                                        },
                                                                        children: [
                                                                            project.government.name,
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                                                                                maxWidth: "230px",
                                                                                textAlign: "center",
                                                                                "aria-label": project.government.name,
                                                                                label: project.government.city.countryName,
                                                                                bg: "blue.600",
                                                                                py: 2,
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                                                    as: "span",
                                                                                    display: "inline-block",
                                                                                    ml: 2,
                                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                                                                        countryCode: project.government.city.country,
                                                                                        width: 25,
                                                                                        height: 14
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                });
                                                            }
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }));
        }
    });
};
function getProjectLink(project) {
    return {
        href: "/projects/[projectSlug]",
        as: "/projects/".concat(project.slug)
    };
}
function getEditProjectLink(project) {
    return {
        href: "/projects/[projectSlug]/edit",
        as: "/projects/".concat(project.slug, "/edit")
    };
}
/* harmony default export */ var feed_ProjectFeed = (ProjectFeed);

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./components/mediaQueries.ts
var mediaQueries = __webpack_require__(92418);
;// CONCATENATED MODULE: ./components/feed/StoryFeed.tsx



















var StoryFeed = function(param) {
    var story = param.story, context = param.context, createdAt = param.createdAt;
    var viewer = (0,Auth/* useSelfie */.yD)();
    var intl = (0,useIntl/* default */.Z)();
    var author = story.author, government = story.government;
    var isAdminAuthor = isAdmin(author);
    var storyLink = {
        href: "/stories/[storySlug]",
        as: "/stories/".concat(story.slug)
    };
    var editStoryLink = {
        href: "/edit-story?storySlug=".concat(story.slug),
        as: "/stories/".concat(story.slug, "/edit")
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var bind = param.bind, hovered = param.hovered;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeedCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: {
                    opacity: story.viewerCanRead ? 1 : 0.5
                }
            }, bind), {
                children: [
                    viewer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleUpvote/* default */.Z, {
                        viewer: viewer,
                        upvotesCount: story.upvotesCount || 0,
                        viewerDidUpvote: story.viewerDidUpvote || false,
                        targetType: "STORY",
                        targetId: story._id,
                        children: function(param) {
                            var toggleUpvote = param.toggle;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleBookmark/* default */.Z, {
                                targetId: story._id,
                                targetType: "STORY",
                                viewerDidBookmark: story.viewerDidBookmark || false,
                                children: function(param) {
                                    var toggleBookmark = param.toggle;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedCardActions/* default */.Z, {
                                        isShowing: hovered,
                                        viewerDidUpvote: story.viewerDidUpvote || false,
                                        onUpvote: toggleUpvote,
                                        viewerDidBookmark: story.viewerDidBookmark || false,
                                        onBookmark: toggleBookmark,
                                        link: storyLink,
                                        viewerCanEdit: story.viewerIsAuthor || story.viewerIsCollaborator || false,
                                        editLink: editStoryLink,
                                        viewerDidComment: story.viewerDidComment || false
                                    });
                                }
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            government ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedAuthorPicture/* default */.Z, {
                                author: author,
                                government: government,
                                gatedAuthor: isAdminAuthor,
                                context: context
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/vendor?vendorSlug=govlaunch-inc",
                                as: "/vendors/govlaunch-inc",
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: {
                                        borderRadius: "100%",
                                        width: 45,
                                        height: 45,
                                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Logo */.TR, {
                                        size: 32
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                ml: 10,
                                children: [
                                    government ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedCardPitch/* default */.Z, {
                                        author: author,
                                        gatedAuthor: isAdminAuthor,
                                        government: government,
                                        action: intl.formatMessage({
                                            id: "uxICV0",
                                            defaultMessage: "shared a"
                                        }),
                                        target: intl.formatMessage({
                                            defaultMessage: "story",
                                            id: "NHDJKH"
                                        }),
                                        targetLink: storyLink,
                                        date: createdAt
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: (0,mediaQueries/* default */.Z)({
                                            color: palette/* darkGray */.O5,
                                            display: "flex",
                                            flexDirection: [
                                                "column",
                                                "row"
                                            ],
                                            fontSize: 15
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                href: "/vendor?vendorSlug=govlaunch-inc",
                                                as: "/vendors/govlaunch-inc",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                    css: {
                                                        color: palette/* primary */.T$,
                                                        fontWeight: "bold",
                                                        ":hover": {
                                                            textDecoration: "underline !important"
                                                        }
                                                    },
                                                    children: "Govlaunch"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                mx: [
                                                    0,
                                                    5
                                                ],
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/stories/[storySlug]",
                                                    as: "/stories/".concat(story.slug),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                        css: {
                                                            color: palette/* darkGray */.O5,
                                                            fontWeight: 600,
                                                            ":hover": {
                                                                textDecoration: "underline !important"
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "shared a story",
                                                            id: "zl2cG8"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedCardPitch/* Time */.q, {
                                                date: createdAt,
                                                targetLink: {
                                                    href: "/vendor?vendorSlug=govlaunch-inc",
                                                    as: "/vendors/govlaunch-inc"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 9,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                fontSize: 15,
                                                display: "flex"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, storyLink), {
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                        css: {
                                                            color: palette/* darkGray */.O5,
                                                            fontWeight: "bold",
                                                            wordBreak: "break-word",
                                                            ":hover": {
                                                                textDecoration: "underline !important"
                                                            }
                                                        },
                                                        children: story.title
                                                    })
                                                })),
                                                !isAdminAuthor && government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                    mx: 5,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        css: {
                                                            color: palette/* darkGray */.O5
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "in <location></location>",
                                                            id: "atBiSP",
                                                            values: {
                                                                // eslint-disable-next-line react/display-name
                                                                location: function() {
                                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                        href: "/government?governmentSlug=".concat(government.slug),
                                                                        as: "/governments/".concat(government.slug),
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                                            css: {
                                                                                color: palette/* mediumGray */.rF,
                                                                                ":hover": {
                                                                                    textDecoration: "underline !important"
                                                                                }
                                                                            },
                                                                            children: government.name
                                                                        })
                                                                    });
                                                                }
                                                            }
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }));
        }
    });
};
/* harmony default export */ var feed_StoryFeed = (StoryFeed);

// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./lib/mutations/ToggleFollow.tsx + 1 modules
var ToggleFollow = __webpack_require__(81177);
// EXTERNAL MODULE: ./src/shared/components/IntlRelativeTime.tsx
var IntlRelativeTime = __webpack_require__(89989);
;// CONCATENATED MODULE: ./components/feed/FollowButton.tsx







var FollowButton = function(param) {
    var isFollowing = param.isFollowing, onFollow = param.onFollow, color = param.color, onUnfollow = param.onUnfollow;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            if (!isFollowing) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    theme: "secondary",
                    color: color,
                    size: "xsmall",
                    onClick: onFollow
                }, bind), {
                    css: {
                        border: 0,
                        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5)",
                        background: "#fff",
                        minWidth: 135,
                        textTransform: "uppercase",
                        fontWeight: 600
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Follow",
                        id: "ieGrWo"
                    })
                }));
            }
            if (!hovered) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    theme: "secondary",
                    color: color,
                    size: "xsmall",
                    onClick: onUnfollow
                }, bind), {
                    css: {
                        border: 0,
                        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5)",
                        background: "#fff",
                        minWidth: 135,
                        textTransform: "uppercase",
                        fontWeight: 600
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Following",
                        id: "cPIKU2"
                    })
                }));
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                theme: "secondary",
                color: color,
                size: "xsmall",
                onClick: onUnfollow
            }, bind), {
                css: {
                    border: 0,
                    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5)",
                    background: "#fff",
                    minWidth: 135,
                    textTransform: "uppercase",
                    fontWeight: 600
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Unfollow",
                    id: "izWS4J"
                })
            }));
        }
    });
};

;// CONCATENATED MODULE: ./components/feed/UserJoinedGovernmentFeed.tsx












var UserJoinedGovernmentFeed = function(param) {
    var user = param.user, createdAt = param.createdAt;
    var loggedInUser = (0,Auth/* useSelfie */.yD)();
    var index = Math.round(Math.random() * 1);
    var background = [
        "/static/feed/blue-background.png",
        "/static/feed/purple-background.png"
    ][index];
    var buttonColor = [
        "#166e6a",
        "#5a3b8d"
    ][index];
    var government = user.government;
    var isMobile = (0,useIsMobile/* default */.Z)();
    if (!government || !loggedInUser) {
        return null;
    }
    var followButton = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleFollow/* default */.Z, {
        targetId: user._id,
        entityType: user.__typename,
        viewerIsFollowing: user.isFollowing || false,
        children: function(param) {
            var toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FollowButton, {
                isFollowing: user.isFollowing || false,
                onFollow: toggle,
                onUnfollow: toggle,
                color: buttonColor
            });
        }
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeedCard/* default */.Z, {
        css: {
            backgroundImage: "url(".concat(background, ")"),
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedAuthorPicture/* default */.Z, {
                        author: user,
                        government: government
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            marginLeft: 12
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                css: {
                                    color: "#fff",
                                    fontSize: 15
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        passHref: true,
                                        href: "/[userSlug]/[[...tab]]",
                                        as: "/@".concat(user.slug),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            css: {
                                                color: "#fff",
                                                fontWeight: 600,
                                                ":hover": {
                                                    textDecoration: "underline !important"
                                                }
                                            },
                                            children: user.fullName
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "joined",
                                                id: "WNcxGO"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: "/governments/[governmentSlug]/[[...content]]",
                                        as: "/governments/".concat(government.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                            css: {
                                                color: "#fff",
                                                fontWeight: 600,
                                                display: "inline-flex",
                                                alignItems: "center",
                                                ":hover": {
                                                    textDecoration: "underline !important"
                                                }
                                            },
                                            children: [
                                                government.name,
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                    as: "span",
                                                    display: "inline-block",
                                                    ml: 2,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                                        countryCode: government.city.country,
                                                        width: 25,
                                                        height: 14
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    color: "#fff",
                                    margin: "8px 0 0",
                                    fontSize: 14
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                    value: createdAt
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            marginLeft: "auto"
                        },
                        children: followButton
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginTop: 12,
                    display: "flex",
                    justifyContent: "center"
                },
                children: followButton
            })
        ]
    });
};
/* harmony default export */ var feed_UserJoinedGovernmentFeed = (UserJoinedGovernmentFeed);

// EXTERNAL MODULE: ./components/feed/PostFeedItem.tsx
var PostFeedItem = __webpack_require__(28933);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
;// CONCATENATED MODULE: ./components/feed/GovermentJoinedGroupFeedItem.tsx







var GovernmentJoinedGroupFeedItem = function(param) {
    var government = param.government, createdAt = param.createdAt;
    var index = Math.round(Math.random() * 1);
    var background = [
        "/static/feed/blue-background.png",
        "/static/feed/purple-background.png"
    ][index];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedCard/* default */.Z, {
        css: {
            backgroundImage: "url(".concat(background, ")"),
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/governments/[governmentSlug]/[[...content]]",
                    as: "/governments/".concat(government.slug),
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        css: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                            size: 45,
                            image: government.logo,
                            name: government.name
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        marginLeft: 12
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: "#fff",
                                fontSize: 15
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/governments/[governmentSlug]/[[...content]]",
                                    as: "/governments/".concat(government.slug),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            color: "#fff",
                                            fontWeight: 600,
                                            ":hover": {
                                                textDecoration: "underline !important"
                                            }
                                        },
                                        children: government.name
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "joined this group",
                                            id: "bHJLnv"
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                color: "#fff",
                                margin: "8px 0 0",
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                value: createdAt
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GovermentJoinedGroupFeedItem = (GovernmentJoinedGroupFeedItem);

;// CONCATENATED MODULE: ./components/feed/VendorJoinedGroupFeedItem.tsx







var VendorJoinedGroupFeedItem = function(param) {
    var vendor = param.vendor, createdAt = param.createdAt;
    var index = Math.round(Math.random() * 1);
    // eslint-disable-next-line react/hook-use-state
    var ref = (0,react.useState)([
        "/static/feed/blue-background.png",
        "/static/feed/purple-background.png"
    ][index]), background = ref[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedCard/* default */.Z, {
        css: {
            backgroundImage: "url(".concat(background, ")"),
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/vendors/[vendorSlug]",
                    as: "/vendors/".concat(vendor.slug),
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        css: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                            size: 45,
                            image: vendor.logo,
                            name: vendor.name
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        marginLeft: 12
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: "#fff",
                                fontSize: 15
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/vendors/[vendorSlug]",
                                    as: "/vendors/".concat(vendor.slug),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            color: "#fff",
                                            fontWeight: 600,
                                            ":hover": {
                                                textDecoration: "underline !important"
                                            }
                                        },
                                        children: vendor.name
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "joined this group",
                                            id: "bHJLnv"
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                color: "#fff",
                                margin: "8px 0 0",
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                value: createdAt
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var feed_VendorJoinedGroupFeedItem = (VendorJoinedGroupFeedItem);

;// CONCATENATED MODULE: ./components/feed/UserJoinedGroupFeedItem.tsx









var UserJoinedGroupFeedItem = function(param) {
    var user = param.user, createdAt = param.createdAt;
    var index = Math.round(Math.random() * 1);
    var background = [
        "/static/feed/blue-background.png",
        "/static/feed/purple-background.png"
    ][index];
    var buttonColor = [
        "#166e6a",
        "#5a3b8d"
    ][index];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedCard/* default */.Z, {
        css: {
            backgroundImage: "url(".concat(background, ")"),
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    passHref: true,
                    href: "/[userSlug]/[[...tab]]",
                    as: "/@".concat(user.slug),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        css: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                            size: 45,
                            image: user.avatar,
                            name: user.fullName
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        marginLeft: 12
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: "#fff",
                                fontSize: 15
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    passHref: true,
                                    href: "/[userSlug]/[[...tab]]",
                                    as: "/@".concat(user.slug),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            color: "#fff",
                                            fontWeight: 600,
                                            ":hover": {
                                                textDecoration: "underline !important"
                                            }
                                        },
                                        children: user.fullName
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "joined this group",
                                            id: "bHJLnv"
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                color: "#fff",
                                margin: "8px 0 0",
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                value: createdAt
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        marginLeft: "auto"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleFollow/* default */.Z, {
                        targetId: user._id,
                        entityType: user.__typename,
                        viewerIsFollowing: user.isFollowing || false,
                        children: function(param) {
                            var toggle = param.toggle;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FollowButton, {
                                isFollowing: user.isFollowing || false,
                                onFollow: toggle,
                                onUnfollow: toggle,
                                color: buttonColor
                            });
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var feed_UserJoinedGroupFeedItem = (UserJoinedGroupFeedItem);

;// CONCATENATED MODULE: ./components/feed/FeedItem.tsx











var FeedItem = function(param) {
    var feedItem = param.feedItem, context = param.context;
    var target = feedItem.target, createdAt = feedItem.createdAt;
    if (!target) {
        return null;
    }
    if (target.__typename === "GroupProject" || target.__typename === "GovernmentProject" || target.__typename === "VendorProject") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(feed_ProjectFeed, {
            project: target,
            createdAt: createdAt,
            context: context
        }, feedItem._id);
    }
    if (target.__typename === "Story") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(feed_StoryFeed, {
            story: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target), {
                government: target.storyGovernment
            }),
            createdAt: createdAt,
            context: context
        }, feedItem._id);
    }
    if (context === "group" && (target.__typename === "GovernmentUser" || target.__typename === "VendorUser" || target.__typename === "PendingUser")) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(feed_UserJoinedGroupFeedItem, {
            user: target,
            createdAt: createdAt
        }, feedItem._id);
    }
    if (target.__typename === "Government") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovermentJoinedGroupFeedItem, {
            government: target,
            createdAt: createdAt
        }, feedItem._id);
    }
    if (target.__typename === "Company") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(feed_VendorJoinedGroupFeedItem, {
            vendor: target,
            createdAt: createdAt
        }, feedItem._id);
    }
    if (target.__typename === "GovernmentUser") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(feed_UserJoinedGovernmentFeed, {
            user: target,
            createdAt: createdAt
        }, feedItem._id);
    }
    if (target.__typename === "GovernmentPost" || target.__typename === "GroupPost" || target.__typename === "VendorPost") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostFeedItem/* default */.Z, {
            createdAt: createdAt,
            context: context,
            post: {
                _id: target._id,
                body: target.body,
                upvotesCount: target.upvotesCount,
                commentsCount: target.commentsCount,
                viewerDidBookmark: target.viewerDidBookmark,
                viewerDidUpvote: target.viewerDidUpvote,
                viewerDidComment: target.viewerDidComment,
                viewerCanEdit: target.viewerCanEdit,
                group: target.__typename === "GroupPost" ? target.postGroup : null,
                vendor: target.__typename === "VendorPost" ? target.postVendor : null,
                government: target.__typename === "GovernmentPost" ? target.postGovernment : null,
                createdAt: target.created,
                author: target.postAuthor,
                attachments: target.postAttachments,
                links: target.postLinks,
                audience: target.postAudience
            }
        }, target._id);
    }
    return null;
};
/* harmony default export */ var feed_FeedItem = (FeedItem);


/***/ }),

/***/ 28933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PostFeedItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56262);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _lib_mutations_ToggleUpvote__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97511);
/* harmony import */ var _components_auth_Auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27068);
/* harmony import */ var _lib_mutations_ToggleBookmark__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96495);
/* harmony import */ var _components_feed_card_FeedCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35321);
/* harmony import */ var react_powerplug__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41491);
/* harmony import */ var _components_feed_card_FeedCardActions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95896);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35150);
/* harmony import */ var _components_post_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57276);
/* harmony import */ var _components_post_PostFormModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94742);
/* harmony import */ var _components_post_PostDetails__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51875);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67459);
















function PostFeedItem(param) {
    var post = param.post, context = param.context;
    var viewer = (0,_components_auth_Auth__WEBPACK_IMPORTED_MODULE_2__/* .useSelfie */ .yD)();
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(false), 2), isOpen = ref[0], toggleOpen = ref[1];
    var postLink = {
        href: "/post?postId=".concat(post._id),
        as: "/posts/".concat(post._id)
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_post_PostFormModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                initialValues: (0,_components_post_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertPostToInitialValues */ .V)(post),
                isOpen: isOpen,
                onRequestClose: toggleOpen
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(react_powerplug__WEBPACK_IMPORTED_MODULE_5__/* .Hover */ .TM, {
                children: function(param) {
                    var bind = param.bind, hovered = param.hovered;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_components_feed_card_FeedCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, bind), {
                        children: [
                            viewer && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_lib_mutations_ToggleUpvote__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                viewer: viewer,
                                upvotesCount: post.upvotesCount || 0,
                                viewerDidUpvote: post.viewerDidUpvote || false,
                                targetType: "POST",
                                targetId: post._id,
                                children: function(param) {
                                    var toggleUpvote = param.toggle;
                                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_lib_mutations_ToggleBookmark__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        targetId: post._id,
                                        targetType: "POST",
                                        viewerDidBookmark: post.viewerDidBookmark || false,
                                        children: function(param) {
                                            var toggleBookmark = param.toggle;
                                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_feed_card_FeedCardActions__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                isShowing: hovered || isMobile,
                                                viewerDidUpvote: post.viewerDidUpvote || false,
                                                onUpvote: toggleUpvote,
                                                viewerDidBookmark: post.viewerDidBookmark || false,
                                                onBookmark: toggleBookmark,
                                                link: postLink,
                                                viewerCanEdit: post.viewerCanEdit || false,
                                                onEdit: toggleOpen,
                                                viewerDidComment: post.viewerDidComment || false
                                            });
                                        }
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_post_PostDetails__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                post: post,
                                context: context
                            })
                        ]
                    }));
                }
            })
        ]
    });
};


/***/ }),

/***/ 54436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WriteContentBox; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./src/components/project/CreateProjectModal.tsx
var CreateProjectModal = __webpack_require__(23115);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
;// CONCATENATED MODULE: ./components/icons/CreateIcon.tsx





var CreateIcon = function(_param) /*#__PURE__*/ {
    var _stroke = _param.stroke, stroke = _stroke === void 0 ? "#666" : _stroke, props = (0,_object_without_properties/* default */.Z)(_param, [
        "stroke"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 16,
        height: 16
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M3.012 14.835l-.431-.028a1.264 1.264 0 01-1.168-1.184l-.013-.23a80.165 80.165 0 010-10.57l.013-.23c.05-.63.547-1.13 1.168-1.173l.225-.014a76.354 76.354 0 0110.401 0l.226.014c.62.05 1.111.555 1.154 1.187l.013.23c.233 3.519.233 7.05 0 10.57l-.013.23a1.266 1.266 0 01-1.168 1.175 76.9 76.9 0 01-10.407.023zM8 4.902v6.426M4.839 8.115h6.322",
            fill: "none",
            fillRule: "evenodd",
            stroke: stroke,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.933
        })
    }));
};
/* harmony default export */ var icons_CreateIcon = (CreateIcon);

;// CONCATENATED MODULE: ./components/icons/UserProfileIcon.tsx





var UserProfileIcon = function(_param) /*#__PURE__*/ {
    var _stroke = _param.stroke, stroke = _stroke === void 0 ? "#666" : _stroke, props = (0,_object_without_properties/* default */.Z)(_param, [
        "stroke"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 16,
        height: 16
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: stroke,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.96,
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M2.012 13.835l-.431-.028a1.264 1.264 0 01-1.168-1.184l-.013-.23a80.165 80.165 0 010-10.57l.013-.23C.463.963.96.463 1.581.42l.225-.014a76.354 76.354 0 0110.401 0l.226.014c.62.05 1.111.555 1.154 1.187l.013.23c.233 3.519.233 7.05 0 10.57l-.013.23a1.266 1.266 0 01-1.168 1.175 76.9 76.9 0 01-10.407.023z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    cx: 7,
                    cy: 3.902,
                    rx: 2.032,
                    ry: 2.066
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M4.672 12.334h-.199a.535.535 0 01-.546-.434v-.083a23.12 23.12 0 010-3.874v-.082a.537.537 0 01.544-.436h.102a46.291 46.291 0 014.854 0h.102a.537.537 0 01.544.436v.082a23.12 23.12 0 010 3.874v.083a.535.535 0 01-.544.436 45.75 45.75 0 01-4.857-.002z"
                })
            ]
        })
    }));
};
/* harmony default export */ var icons_UserProfileIcon = (UserProfileIcon);

// EXTERNAL MODULE: ./components/mediaQueries.ts
var mediaQueries = __webpack_require__(92418);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/post/icons/LinksToolbarIcon.tsx
var LinksToolbarIcon = __webpack_require__(65153);
// EXTERNAL MODULE: ./components/post/icons/ImageToolbarIcon.tsx
var ImageToolbarIcon = __webpack_require__(53486);
// EXTERNAL MODULE: ./components/post/icons/DocumentToolbarIcon.tsx
var DocumentToolbarIcon = __webpack_require__(26094);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-outside-click-handler@1.3.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-outside-click-handler/index.js
var react_outside_click_handler = __webpack_require__(5476);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./components/post/RemoveButton.tsx
var RemoveButton = __webpack_require__(32788);
// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
// EXTERNAL MODULE: ./components/post/fields/LinkField.tsx
var LinkField = __webpack_require__(21836);
// EXTERNAL MODULE: ./components/post/DocumentCard.tsx
var DocumentCard = __webpack_require__(31186);
// EXTERNAL MODULE: ./components/post/utils.ts
var utils = __webpack_require__(57276);
// EXTERNAL MODULE: ./lib/mutations/PostToGovernment.ts
var PostToGovernment = __webpack_require__(81525);
// EXTERNAL MODULE: ./lib/mutations/PostToGroup.ts
var PostToGroup = __webpack_require__(31002);
// EXTERNAL MODULE: ./lib/mutations/EditPost.ts
var EditPost = __webpack_require__(97165);
// EXTERNAL MODULE: ./components/form/FieldValidationError.tsx
var FieldValidationError = __webpack_require__(80360);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-textarea-autosize@8.3.4_skqlhrap4das3cz5b6iqdn2lqi/node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(69585);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/index.js
var react_dom = __webpack_require__(87995);
// EXTERNAL MODULE: ./components/post/LinkCard.tsx
var LinkCard = __webpack_require__(3361);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
// EXTERNAL MODULE: ./lib/queries/fragments/VendorPostFields.ts
var VendorPostFields = __webpack_require__(50472);
;// CONCATENATED MODULE: ./lib/mutations/PostToVendor.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PostToVendor($vendor: ObjectId!, $post: PostInput!) {\n    postToVendor(vendor: $vendor, post: $post) {\n      ... on VendorPost {\n        _id\n        ...VendorPostFields\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var PostToVendor = ((0,lib/* gql */.Ps)(_templateObject(), VendorPostFields/* default */.Z));

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./lib/hooks/useIntlValidationMessages.ts
var useIntlValidationMessages = __webpack_require__(67308);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
;// CONCATENATED MODULE: ./components/post/PostForm.tsx





































var POST_INITIAL_STATE = {
    links: [],
    documents: [],
    images: [],
    audience: "community"
};
function PostForm(param) {
    var government = param.government, group = param.group, vendor = param.vendor, _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? POST_INITIAL_STATE : _initialValues;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), isFocused = ref[0], setIsFocused = ref[1];
    var ref1 = (0,react.useState)(false), isAddingLink = ref1[0], setIsAddingLink = ref1[1];
    var user = (0,Auth/* useSelfie */.yD)();
    var formRef = /*#__PURE__*/ (0,react.createRef)();
    var intlValidationMessages = (0,useIntlValidationMessages/* default */.Z)();
    var validationSchema = es/* object */.Ry().shape({
        body: es/* string */.Z_().required(intlValidationMessages.cantBeBlank).min(3, intlValidationMessages.minCharacters(3)).max(280, intlValidationMessages.maxCharacters(200))
    });
    if (!initialValues._id && (!government && !group && !vendor || government && group && vendor)) {
        throw new Error("Please specify either `government`, `vendor` or `group`");
    }
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                mutation: PostToVendor,
                children: function(postToVendor) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                        mutation: PostToGovernment/* default */.Z,
                        children: function(postToGovernment) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                mutation: PostToGroup/* default */.Z,
                                children: function(postToGroup) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                        mutation: EditPost/* default */.Z,
                                        children: function(editPost) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                                                initialValues: initialValues,
                                                onSubmit: function() {
                                                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                                                        var reset;
                                                        return runtime_default().wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    reset = param.reset;
                                                                    if (!initialValues._id) {
                                                                        _ctx.next = 4;
                                                                        break;
                                                                    }
                                                                    _ctx.next = 4;
                                                                    return editPost({
                                                                        variables: {
                                                                            id: initialValues._id,
                                                                            post: (0,utils/* convertValuesToVariables */.R)(values)
                                                                        }
                                                                    });
                                                                case 4:
                                                                    if (!government) {
                                                                        _ctx.next = 9;
                                                                        break;
                                                                    }
                                                                    _ctx.next = 7;
                                                                    return postToGovernment({
                                                                        variables: {
                                                                            government: government._id,
                                                                            post: (0,utils/* convertValuesToVariables */.R)(values)
                                                                        }
                                                                    });
                                                                case 7:
                                                                    _ctx.next = 17;
                                                                    break;
                                                                case 9:
                                                                    if (!vendor) {
                                                                        _ctx.next = 14;
                                                                        break;
                                                                    }
                                                                    _ctx.next = 12;
                                                                    return postToVendor({
                                                                        variables: {
                                                                            vendor: vendor._id,
                                                                            post: (0,utils/* convertValuesToVariables */.R)(values)
                                                                        }
                                                                    });
                                                                case 12:
                                                                    _ctx.next = 17;
                                                                    break;
                                                                case 14:
                                                                    if (!group) {
                                                                        _ctx.next = 17;
                                                                        break;
                                                                    }
                                                                    _ctx.next = 17;
                                                                    return postToGroup({
                                                                        variables: {
                                                                            group: group._id,
                                                                            post: (0,utils/* convertValuesToVariables */.R)(values)
                                                                        }
                                                                    });
                                                                case 17:
                                                                    setIsFocused(false);
                                                                    setTimeout(reset, 1);
                                                                    return _ctx.abrupt("return", null);
                                                                case 20:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    }));
                                                    return function(values, _) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }(),
                                                validate: (0,validate/* default */.Z)(validationSchema),
                                                children: function(param) {
                                                    var handleSubmit = param.handleSubmit, form = param.form, values = param.values, invalid = param.invalid;
                                                    var showIconOptions = values.images.length === 0 && values.documents.length === 0 && !isAddingLink && values.links.length === 0;
                                                    var showPostButton = isFocused;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_outside_click_handler["default"], {
                                                        onOutsideClick: function() {
                                                            var filestackIsOpen = document.getElementById("__filestack-picker");
                                                            if (!filestackIsOpen) {
                                                                setIsFocused(false);
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                                                            ref: formRef,
                                                            onSubmit: handleSubmit,
                                                            css: {
                                                                padding: 16,
                                                                background: "#fff",
                                                                borderRadius: 4
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    css: {
                                                                        borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                                                                        paddingBottom: 12
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                        css: {
                                                                            display: "flex"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                                                image: user.avatar,
                                                                                name: user.fullName,
                                                                                size: 45
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                                                name: "body",
                                                                                children: function(param) {
                                                                                    var input = param.input, meta = param.meta;
                                                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                                        css: {
                                                                                            width: "100%"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_textarea_autosize_browser_esm/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                                                                                                "onFocus"
                                                                                            ], input)), {
                                                                                                onKeyDown: function(e) {
                                                                                                    if (e.key === "Escape") {
                                                                                                        setIsFocused(false);
                                                                                                        e.target.blur();
                                                                                                    }
                                                                                                },
                                                                                                minRows: isFocused ? 4 : 2,
                                                                                                onFocus: function() {
                                                                                                    return setIsFocused(true);
                                                                                                },
                                                                                                placeholder: intl.formatMessage({
                                                                                                    defaultMessage: "What would you like to share, {firstName}?",
                                                                                                    id: "DnymrA"
                                                                                                }, {
                                                                                                    firstName: user.firstName
                                                                                                }),
                                                                                                css: {
                                                                                                    width: "100%",
                                                                                                    padding: 10,
                                                                                                    overflow: "hidden",
                                                                                                    color: palette/* darkGray */.O5,
                                                                                                    fontSize: 15,
                                                                                                    border: 0,
                                                                                                    borderRadius: 4,
                                                                                                    outline: 0,
                                                                                                    transition: "height 0.3s",
                                                                                                    resize: "none",
                                                                                                    "&::placeholder": {
                                                                                                        color: palette/* darkGray */.O5,
                                                                                                        fontSize: 16,
                                                                                                        userSelect: "none"
                                                                                                    }
                                                                                                }
                                                                                            })),
                                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                                                css: {
                                                                                                    marginLeft: 10
                                                                                                },
                                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                                                                    meta: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, meta), {
                                                                                                        touched: isFocused ? meta.touched : false
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                values.images.map(function(image) {
                                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                        css: {
                                                                            marginTop: 12,
                                                                            position: "relative"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                                                                src: image.url,
                                                                                css: {
                                                                                    maxHeight: 250,
                                                                                    maxWidth: "100%",
                                                                                    objectFit: "contain",
                                                                                    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.39)"
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RemoveButton/* default */.Z, {
                                                                                onClick: function() {
                                                                                    return form.change("images", []);
                                                                                },
                                                                                css: {
                                                                                    position: "absolute",
                                                                                    top: 10,
                                                                                    left: 10
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, image.url);
                                                                }),
                                                                values.links && Array.isArray(values.links) && values.links.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    css: {
                                                                        marginTop: 15
                                                                    },
                                                                    children: values.links.map(function(_param) {
                                                                        var url = _param.url, meta = (0,_object_without_properties/* default */.Z)(_param, [
                                                                            "url"
                                                                        ]);
                                                                        if (!meta) {
                                                                            return null;
                                                                        }
                                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkCard/* default */.Z, {
                                                                                url: url || "",
                                                                                title: meta.title || "",
                                                                                siteName: meta.siteName || "",
                                                                                description: meta.description || "",
                                                                                favicon: meta.favicon || "",
                                                                                onRemove: function() {
                                                                                    form.change("links", []);
                                                                                }
                                                                            })
                                                                        }, url || "");
                                                                    })
                                                                }),
                                                                values.documents.map(function(document1) {
                                                                    var filename = document1.filename, mimeType = document1.mimeType, sizeInBytes = document1.sizeInBytes, url = document1.url;
                                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                        mt: 12,
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocumentCard/* default */.Z, {
                                                                            url: url,
                                                                            filename: filename,
                                                                            mimeType: mimeType,
                                                                            sizeInBytes: sizeInBytes,
                                                                            onRemove: function() {
                                                                                return form.change("documents", []);
                                                                            }
                                                                        })
                                                                    }, url);
                                                                }),
                                                                isAddingLink && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                    mt: 12,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkField/* default */.Z, {
                                                                        onCancel: function() {
                                                                            return setIsAddingLink(false);
                                                                        }
                                                                    })
                                                                }),
                                                                (showIconOptions || showPostButton) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                                                    mt: 12,
                                                                    css: {
                                                                        display: "flex",
                                                                        alignItems: "center"
                                                                    },
                                                                    children: [
                                                                        showIconOptions && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                            css: {
                                                                                display: "grid",
                                                                                gridTemplateColumns: "repeat(3, 1fr)",
                                                                                gridColumnGap: 12,
                                                                                maxWidth: 121
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarItem, {
                                                                                    tooltip: intl.formatMessage({
                                                                                        defaultMessage: "Link",
                                                                                        id: "JBWS0c"
                                                                                    }),
                                                                                    onClick: function() {
                                                                                        setIsFocused(true);
                                                                                        setIsAddingLink(true);
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinksToolbarIcon/* default */.Z, {})
                                                                                }),
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                                                    name: "images",
                                                                                    children: function(param) {
                                                                                        var input = param.input;
                                                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
                                                                                            options: {
                                                                                                accept: [
                                                                                                    "image/jpeg",
                                                                                                    "image/jpg",
                                                                                                    "image/png",
                                                                                                    "image/gif"
                                                                                                ]
                                                                                            },
                                                                                            onSuccess: function(param) {
                                                                                                var filesUploaded = param.filesUploaded;
                                                                                                if (filesUploaded.length > 0) {
                                                                                                    var file = filesUploaded[0];
                                                                                                    input.onChange([
                                                                                                        {
                                                                                                            filename: file.filename,
                                                                                                            mimeType: file.mimetype,
                                                                                                            sizeInBytes: file.size,
                                                                                                            url: file.url
                                                                                                        }, 
                                                                                                    ]);
                                                                                                    form.change("documents", []);
                                                                                                    form.change("links", []);
                                                                                                }
                                                                                            },
                                                                                            customRender: function(param) {
                                                                                                var onPick = param.onPick;
                                                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarItem, {
                                                                                                    tooltip: intl.formatMessage({
                                                                                                        defaultMessage: "Image",
                                                                                                        id: "+0zv6g"
                                                                                                    }),
                                                                                                    onClick: onPick,
                                                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageToolbarIcon/* default */.Z, {})
                                                                                                });
                                                                                            }
                                                                                        });
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                                                    name: "documents",
                                                                                    children: function(param) {
                                                                                        var input = param.input;
                                                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
                                                                                            options: {
                                                                                                accept: [
                                                                                                    "application/msword",
                                                                                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                                                                    "application/vnd.ms-excel",
                                                                                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                                                                                    "application/pdf", 
                                                                                                ]
                                                                                            },
                                                                                            onSuccess: function(param) {
                                                                                                var filesUploaded = param.filesUploaded;
                                                                                                if (filesUploaded.length > 0) {
                                                                                                    var file = filesUploaded[0];
                                                                                                    input.onChange([
                                                                                                        {
                                                                                                            filename: file.filename,
                                                                                                            mimeType: file.mimetype,
                                                                                                            sizeInBytes: file.size,
                                                                                                            url: file.url
                                                                                                        }, 
                                                                                                    ]);
                                                                                                    form.change("links", []);
                                                                                                    form.change("images", []);
                                                                                                }
                                                                                            },
                                                                                            customRender: function(param) {
                                                                                                var onPick = param.onPick;
                                                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarItem, {
                                                                                                    tooltip: intl.formatMessage({
                                                                                                        defaultMessage: "Document",
                                                                                                        id: "wmirkP"
                                                                                                    }),
                                                                                                    onClick: onPick,
                                                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocumentToolbarIcon/* default */.Z, {})
                                                                                                });
                                                                                            }
                                                                                        });
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }),
                                                                        showPostButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                            css: {
                                                                                display: "inline-flex",
                                                                                marginLeft: "auto"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                                type: "submit",
                                                                                size: "xsmall",
                                                                                color: palette/* innovatorBlue */.LD,
                                                                                disabled: invalid,
                                                                                css: {
                                                                                    ":disabled": {
                                                                                        opacity: 0.6
                                                                                    }
                                                                                },
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                                    defaultMessage: "Post",
                                                                                    id: "eKv7yX"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }),
            isFocused && /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    position: "fixed",
                    top: 0,
                    bottom: isFocused ? "0%" : "100%",
                    left: 0,
                    right: 0,
                    background: "#000",
                    transition: isFocused ? "opacity .3s" : "opacity .3s, bottom 0s .3s",
                    opacity: isFocused ? 0.6 : 0,
                    zIndex: 300
                }
            }), document.body)
        ]
    });
};
var ToolbarItem = function(_param) {
    var _active = _param.active, active = _active === void 0 ? false : _active, tooltip = _param.tooltip, props = (0,_object_without_properties/* default */.Z)(_param, [
        "active",
        "tooltip"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                isOpen: hovered,
                placement: "top",
                backgroundColor: palette/* innovatorBlue */.LD,
                render: function() {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            padding: 8,
                            color: palette/* white */.ix,
                            fontSize: 12,
                            fontWeight: "bold"
                        },
                        children: tooltip
                    });
                },
                borderColor: "transparent",
                boxStyle: {
                    boxShadow: "0 2px 12px 0 rgba(0, 0, 0, 0.2)",
                    zIndex: 9999
                },
                children: function(param) {
                    var innerRef = param.innerRef;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props, bind), {
                        ref: innerRef,
                        css: {
                            height: 35,
                            width: 35,
                            borderRadius: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: active ? "#b9e2fd" : palette/* lightestBlue */.I,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: active ? "#b9e2fd" : palette/* lightBlue */.f7
                            }
                        }
                    }));
                }
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/icons/ListIcon.tsx





var ListIcon = function(_param) /*#__PURE__*/ {
    var _stroke = _param.stroke, stroke = _stroke === void 0 ? "#666" : _stroke, props = (0,_object_without_properties/* default */.Z)(_param, [
        "stroke"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 16,
        height: 16
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M3.012 14.835l-.431-.028a1.264 1.264 0 01-1.168-1.184l-.013-.23a80.165 80.165 0 010-10.57l.013-.23c.05-.63.547-1.13 1.168-1.173l.225-.014a76.354 76.354 0 0110.401 0l.226.014c.62.05 1.111.555 1.154 1.187l.013.23c.233 3.519.233 7.05 0 10.57l-.013.23a1.266 1.266 0 01-1.168 1.175 76.9 76.9 0 01-10.407.023zm1.827-6.72h6.322M4.839 5.82h6.322m-6.322 4.59H8",
            fill: "none",
            fillRule: "evenodd",
            stroke: stroke,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.903
        })
    }));
};
/* harmony default export */ var icons_ListIcon = (ListIcon);

// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
;// CONCATENATED MODULE: ./components/feed/AddProjectContentBox.tsx








function AddProjectContentBox(param) {
    var onClick = param.onClick, context = param.context, groupId = param.groupId;
    var isMobile = (0,useIsMobile/* default */.Z)();
    if (isMobile) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddProjectContentBoxMobile, {
            context: context,
            groupId: groupId
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddProjectButton, {
        onClick: onClick,
        context: context
    });
};
function AddProjectContentBoxMobile(param) {
    var context = param.context, groupId = param.groupId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/projects/create?groupId=".concat(groupId),
        as: "/projects/create",
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddProjectButton, {
            context: context
        })
    });
}
function AddProjectButton(param) {
    var onClick = param.onClick, context = param.context;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
        onClick: onClick,
        role: "button",
        css: (0,mediaQueries/* default */.Z)({
            color: palette/* darkGray */.O5,
            fontWeight: 500,
            width: "100%",
            background: "#fff",
            cursor: "pointer",
            border: "1px solid transparent",
            borderRight: context === "user" ? 0 : "1px solid ".concat(palette/* lightestGray */.v2),
            height: 48,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: [
                11,
                11,
                12,
                12
            ],
            textTransform: "uppercase",
            ":hover": {
                border: "1px solid #9ac4e1"
            }
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_ListIcon, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: {
                    marginLeft: 4
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Add Project",
                    id: "BAZtPp"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/feed/WriteContentBox.tsx











function WriteContentBox(param) {
    var group = param.group, user = param.user, context = param.context, dataIntercomTarget = param.dataIntercomTarget;
    var ref = (0,react.useState)(false), showCreateProjectModal = ref[0], setShowCreateProjectModal = ref[1];
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": dataIntercomTarget,
        css: {
            background: "#fff",
            border: "1px solid ".concat(palette/* lightestGray */.v2),
            borderRadius: 4,
            position: "relative",
            zIndex: 301
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateProjectModal/* default */.Z, {
                isOpen: showCreateProjectModal,
                onClose: function() {
                    return setShowCreateProjectModal(false);
                },
                groupId: group === null || group === void 0 ? void 0 : group._id
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: (0,mediaQueries/* default */.Z)({
                            color: palette/* darkGray */.O5,
                            fontWeight: 500,
                            width: "100%",
                            background: "#ebf4fa",
                            borderRight: "1px solid ".concat(palette/* lightestGray */.v2),
                            height: 48,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: [
                                11,
                                11,
                                12,
                                12
                            ],
                            textTransform: "uppercase"
                        }),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_CreateIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginLeft: 4
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Create Post",
                                    id: "3gMvAC"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddProjectContentBox, {
                        onClick: function() {
                            return setShowCreateProjectModal(true);
                        },
                        groupId: group === null || group === void 0 ? void 0 : group._id,
                        context: context
                    }),
                    context !== "user" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        passHref: true,
                        href: "/[userSlug]/[[...tab]]",
                        as: "/@".concat(user.slug),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                            role: "button",
                            css: (0,mediaQueries/* default */.Z)({
                                color: palette/* darkGray */.O5,
                                fontWeight: 500,
                                width: "100%",
                                background: "#fff",
                                cursor: "pointer",
                                height: 48,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: [
                                    11,
                                    11,
                                    12,
                                    12
                                ],
                                textTransform: "uppercase",
                                border: "1px solid transparent",
                                ":hover": {
                                    border: "1px solid #9ac4e1"
                                }
                            }),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_UserProfileIcon, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        marginLeft: 4
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "My Activity",
                                        id: "XqHKCc"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    borderTop: "1px solid ".concat(palette/* lightestGray */.v2)
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostForm, {
                    government: getPostFormGovernment(group, user),
                    vendor: getPostFormVendor(group, user),
                    group: group
                })
            })
        ]
    });
};
function getPostFormGovernment(group, user) {
    if (group) {
        return undefined;
    }
    if (user && user.__typename === "GovernmentUser" && user.government) {
        return user.government;
    }
    return undefined;
}
function getPostFormVendor(group, user) {
    if (group) {
        return undefined;
    }
    if (user && user.__typename === "VendorUser" && user.company) {
        return user.company;
    }
    return undefined;
}


/***/ }),

/***/ 35321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);






var FeedCard = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: {
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .white */ .ix,
            borderRadius: 4,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .lightestGray */ .v2),
            padding: 16,
            transition: "all .25s",
            position: "relative",
            "&:hover": {
                borderColor: "#9ac4e1"
            }
        }
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FeedCard);


/***/ }),

/***/ 95896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ card_FeedCardActions; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/buttons/BookmarkButtonIcon.tsx
var BookmarkButtonIcon = __webpack_require__(43723);
// EXTERNAL MODULE: ./components/buttons/ThumbsUpButton.tsx
var ThumbsUpButton = __webpack_require__(54208);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
;// CONCATENATED MODULE: ./components/icons/CommentsIconV2.tsx





var CommentsIconV2 = function(_param) /*#__PURE__*/ {
    var _fill = _param.fill, fill = _fill === void 0 ? "#fff" : _fill, _stroke = _param.stroke, stroke = _stroke === void 0 ? "#A5ADBA" : _stroke, props = (0,_object_without_properties/* default */.Z)(_param, [
        "fill",
        "stroke"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 19 18",
        width: 19,
        height: 18
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M9.5 17.46H2.639v-2.94a.184.184 0 00-.045-.12C1.26 12.885.528 10.968.528 9 .528 4.335 4.553.54 9.5.54c4.947 0 8.972 3.795 8.972 8.46 0 4.665-4.025 8.46-8.972 8.46z",
            fillRule: "nonzero",
            fill: fill,
            stroke: stroke
        })
    }));
};
/* harmony default export */ var icons_CommentsIconV2 = (CommentsIconV2);

// EXTERNAL MODULE: ./components/icons/EditIcon.tsx
var EditIcon = __webpack_require__(12135);
;// CONCATENATED MODULE: ./components/feed/card/FeedCardActions.tsx











var FeedCardActions = function(param) {
    var isShowing = param.isShowing, onUpvote = param.onUpvote, viewerDidUpvote = param.viewerDidUpvote, onBookmark = param.onBookmark, viewerDidBookmark = param.viewerDidBookmark, link = param.link, viewerCanEdit = param.viewerCanEdit, editLink = param.editLink, onEdit = param.onEdit, viewerDidComment = param.viewerDidComment;
    var viewer = (0,Auth/* useSelfie */.yD)();
    if (!viewer) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            opacity: isShowing ? 1 : 0,
            position: "absolute",
            gridAutoFlow: "column",
            gridColumnGap: 10,
            top: 16,
            right: 16,
            transition: "opacity .12s"
        },
        children: [
            onUpvote && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThumbsUpButton/* default */.Z, {
                onClick: onUpvote,
                upvoted: viewerDidUpvote || false
            }),
            link && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_CommentsIconV2, {
                        fill: viewerDidComment ? palette/* primary */.T$ : palette/* white */.ix,
                        stroke: viewerDidComment ? palette/* primary */.T$ : palette/* sealBlue */.N9
                    })
                })
            })),
            onBookmark && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookmarkButtonIcon/* default */.Z, {
                onClick: onBookmark,
                bookmarked: viewerDidBookmark || false,
                bookmarkedColor: palette/* primary */.T$,
                bookmarkedStrokeColor: palette/* primary */.T$
            }),
            viewerCanEdit && editLink && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, editLink), {
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditIcon/* default */.Z, {
                        color: palette/* sealBlue */.N9
                    })
                })
            })),
            viewerCanEdit && onEdit && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                type: "button",
                onClick: onEdit,
                css: {
                    border: 0,
                    padding: 0,
                    background: "none",
                    outline: "none",
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditIcon/* default */.Z, {
                    color: palette/* sealBlue */.N9
                })
            })
        ]
    });
};
/* harmony default export */ var card_FeedCardActions = (FeedCardActions);


/***/ }),

/***/ 25936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16629);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95576);




var LoadingFeedCard = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
        css: {
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .white */ .ix,
            borderRadius: 4,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .lightestGray */ .v2)
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(react_content_loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            height: 79,
            width: 730,
            speed: 1,
            foregroundColor: "#f3f3f3",
            backgroundColor: "#ecebeb",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                    cx: "38",
                    cy: "41",
                    r: "23"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("rect", {
                    x: "76",
                    y: "22",
                    rx: "6",
                    ry: "6",
                    width: "330",
                    height: "11"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("rect", {
                    x: "76",
                    y: "47",
                    rx: "6",
                    ry: "6",
                    width: "180",
                    height: "11"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingFeedCard);


/***/ }),

/***/ 20302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var ProjectIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 62,
        height: 62,
        viewBox: "0 0 62 62"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                    cx: 29.949,
                    cy: 29.949,
                    r: 29.949,
                    fill: "#DAEAF6",
                    stroke: "#005AEE",
                    strokeWidth: 0.713,
                    transform: "translate(1 1)"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#48A0D9",
                    d: "M17.027 23.286h27.946c.328 0 .598.258.598.571v.572H16.43v-.572c0-.313.264-.571.598-.571z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M18.143 23.286l12.31-7.754a1.526 1.526 0 011.665 0l12.31 7.754H18.144z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#BFD9EB",
                    d: "M23.022 22.143h15.956a.304.304 0 00.17-.559l-7.813-5.054a.602.602 0 00-.67 0l-7.813 5.054a.301.301 0 00-.124.345.3.3 0 00.294.214z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M17.571 24.429H44.43v2.35c0 .59-.457 1.078-1.023 1.078H18.588c-.56 0-1.017-.488-1.017-1.078v-2.35zm1.143 3.428h4v.781c0 .2-.17.362-.383.362h-3.24a.37.37 0 01-.377-.362v-.78z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M19.286 29h2.857v13.714h-2.857zm10.285 0h2.857v13.714h-2.857z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#92BFE0",
                    d: "M21.571 29h1v13.714h-1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#EFF4F7",
                    d: "M19.286 29h1.143v13.714h-1.143z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M23.857 27.857h4v.781c0 .2-.17.362-.377.362h-3.24a.372.372 0 01-.383-.362v-.78z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M24.428 29h2.857v13.714h-2.857zm9.715-1.143h4v.781c0 .2-.175.362-.383.362h-3.235a.372.372 0 01-.382-.362v-.78z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M34.714 29h2.857v13.714h-2.857zm4.572-1.143h4v.781c0 .2-.17.362-.378.362h-3.245a.37.37 0 01-.377-.362v-.78z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M39.857 29h2.857v13.714h-2.857zm-16 15.429h4v-.782a.37.37 0 00-.377-.361h-3.24a.372.372 0 00-.383.361v.782z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M23.857 44.429h4v-.782a.37.37 0 00-.377-.361h-3.24a.372.372 0 00-.383.361v.782z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M23.857 44.429h4v-.782a.37.37 0 00-.377-.361h-3.24a.372.372 0 00-.383.361v.782zm10.286 0h4v-.782c0-.199-.175-.361-.383-.361h-3.235a.372.372 0 00-.382.361v.782zm5.143 0h4v-.782a.37.37 0 00-.378-.361h-3.245a.37.37 0 00-.377.361v.782z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#45A1DA",
                    d: "M18.1 43.857h26.37c.288 0 .53.273.53.598v1.116H17.571v-1.116c0-.325.236-.598.53-.598z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#BFD9EB",
                    d: "M16.391 45.571h29.224c.292 0 .528.267.528.598v1.117H15.857v-1.117c0-.331.241-.598.534-.598z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#92BFE0",
                    d: "M43.737 27.21h-25.48c-.263 0-.503-.205-.686-.496v.06c0 .593.457 1.083 1.017 1.083h24.818c.566 0 1.023-.49 1.023-1.082v-.06c-.183.29-.429.495-.692.495z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#BFD9EB",
                    d: "M44.429 25.571H17.57V25h26.86z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#92BFE0",
                    d: "M26.623 29h1v13.636h-1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#EFF4F7",
                    d: "M24.429 29h1v13.638h-1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#E4EFF7",
                    d: "M29 28.429h4v.78c0 .2-.17.362-.378.362h-3.239A.372.372 0 0129 29.21v-.781zM18.714 43.857h4v-.781a.37.37 0 00-.377-.362h-3.24a.372.372 0 00-.383.362v.781zm10.286 0h4v-.781a.37.37 0 00-.378-.362h-3.239a.372.372 0 00-.383.362v.781z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#92BFE0",
                    d: "M36.908 29h1v13.636h-1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#EFF4F7",
                    d: "M34.714 29h1v13.638h-1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#92BFE0",
                    d: "M42.051 29h1v13.636h-1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#EFF4F7",
                    d: "M39.857 29h1v13.638h-1z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#48A0D8",
                    d: "M34.38 44.429H18.102c-.294 0-.53.215-.53.471v.671c0-.26.236-.476.53-.476h26.37c.287 0 .529.215.529.476v-.67c0-.257-.242-.472-.53-.472H34.382z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#EFF4F7",
                    d: "M44.69 45.571H16.391c-.293 0-.534.211-.534.474v.67c0-.258.241-.474.534-.474h29.224c.292 0 .528.216.528.473v-.669c0-.263-.236-.474-.528-.474h-.925z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#396182",
                    fillRule: "nonzero",
                    d: "M17.379 23.286h27.813a.99.99 0 01.67.248c.172.156.28.373.28.606V25H16.43v-.86a.81.81 0 01.28-.6v-.006a.99.99 0 01.67-.248zm27.813.637H17.38a.237.237 0 00-.172.062h-.006a.222.222 0 00-.068.155v.223H45.44v-.223a.215.215 0 00-.075-.155.261.261 0 00-.172-.062z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#396182",
                    fillRule: "nonzero",
                    d: "M18.116 23.802a.358.358 0 01-.49-.104.36.36 0 01.104-.492l12.515-8.174a1.88 1.88 0 011.042-.318c.356 0 .713.104 1.041.318l12.51 8.174a.35.35 0 01.103.492.35.35 0 01-.484.104l-12.514-8.18a1.191 1.191 0 00-1.312 0l-12.515 8.18zm.598 2.075c0-.168.162-.306.358-.306.196 0 .352.138.352.306v.532c0 .167-.156.305-.352.305-.196 0-.358-.138-.358-.305v-.532zm23.862 0c0-.168.162-.306.358-.306.196 0 .352.138.352.306v.532c0 .167-.156.305-.352.305-.196 0-.358-.138-.358-.305v-.532zm-2.168 0c0-.168.162-.306.358-.306.196 0 .351.138.351.306v.532c0 .167-.155.305-.351.305-.196 0-.358-.138-.358-.305v-.532zm-2.168 0c0-.168.161-.306.352-.306.196 0 .357.138.357.306v.532c0 .167-.161.305-.357.305-.19 0-.352-.138-.352-.305v-.532zm-2.168 0c0-.168.155-.306.351-.306.197 0 .358.138.358.306v.532c0 .167-.161.305-.358.305-.196 0-.351-.138-.351-.305v-.532zm-2.169 0c0-.168.156-.306.352-.306.196 0 .358.138.358.306v.532c0 .167-.162.305-.358.305-.196 0-.352-.138-.352-.305v-.532zm-2.174 0c0-.168.162-.306.358-.306.196 0 .352.138.352.306v.532c0 .167-.156.305-.352.305-.196 0-.358-.138-.358-.305v-.532zm-2.168 0c0-.168.162-.306.358-.306.196 0 .352.138.352.306v.532c0 .167-.156.305-.352.305-.196 0-.358-.138-.358-.305v-.532zm-2.168 0c0-.168.161-.306.358-.306.196 0 .351.138.351.306v.532c0 .167-.155.305-.351.305-.197 0-.358-.138-.358-.305v-.532zm-2.168 0c0-.168.155-.306.352-.306.196 0 .357.138.357.306v.532c0 .167-.161.305-.357.305-.197 0-.352-.138-.352-.305v-.532zm-2.168 0c0-.168.155-.306.351-.306.196 0 .358.138.358.306v.532c0 .167-.162.305-.358.305-.196 0-.351-.138-.351-.305v-.532zm-2.174 0c0-.168.161-.306.357-.306.196 0 .352.138.352.306v.532c0 .167-.156.305-.352.305-.196 0-.357-.138-.357-.305v-.532zm2.403 1.98v.912a.803.803 0 01-.23.564.776.776 0 01-.56.238h-3.564a.762.762 0 01-.554-.238.809.809 0 01-.235-.564v-.912h.74v.912c0 .013.007.025.013.031h.006a.033.033 0 00.03.018h3.565c.018 0 .03-.006.036-.018.012-.006.012-.018.012-.03v-.913h.74z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#396182",
                    fillRule: "nonzero",
                    d: "M22.714 29l-.016 13.714h-.67L22.046 29h.67zm-3.428 13.714L19.302 29h.664l-.01 13.714h-.67z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
                    fill: "#396182",
                    fillRule: "nonzero",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                            d: "M28.384 27.857v.839c0 .197-.09.383-.227.518a.81.81 0 01-.555.22h-3.534a.81.81 0 01-.555-.22.712.712 0 01-.227-.518v-.839h.734v.839c0 .011.006.022.012.028.006.011.024.017.036.017h3.534c.012 0 .024-.006.036-.017a.042.042 0 00.012-.028v-.839h.734zM27.65 44.17v-.84a.042.042 0 00-.012-.028c-.012-.01-.024-.017-.036-.017h-3.534c-.012 0-.03.006-.036.017a.042.042 0 00-.012.028v.84h-.734v-.84a.69.69 0 01.227-.517.81.81 0 01.555-.22h3.534a.81.81 0 01.555.22c.138.13.227.315.227.517v.84h-.734z"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                            d: "M27.703 29.084v13.858h-.734V29.084h.734zM23.96 42.942V29.084h.735v13.858h-.735z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
                    fill: "#396182",
                    fillRule: "nonzero",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                            d: "M33.527 27.857v.839c0 .197-.09.383-.227.518a.81.81 0 01-.555.22H29.21a.81.81 0 01-.556-.22.712.712 0 01-.226-.518v-.839h.734v.839c0 .011.006.022.012.028.006.011.024.017.036.017h3.534c.012 0 .024-.006.036-.017a.042.042 0 00.012-.028v-.839h.734zm-.734 16.313v-.84a.042.042 0 00-.012-.028c-.012-.01-.024-.017-.036-.017H29.21c-.012 0-.03.006-.036.017a.042.042 0 00-.012.028v.84h-.734v-.84c0-.202.083-.388.226-.517a.81.81 0 01.556-.22h3.534a.81.81 0 01.555.22c.137.13.227.315.227.517v.84h-.734z"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                            d: "M32.846 29.084v13.858h-.734V29.084h.734zm-3.743 13.858V29.084h.734v13.858h-.734z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#396182",
                    fillRule: "nonzero",
                    d: "M38.714 27.857v.912a.82.82 0 01-.229.564.786.786 0 01-.56.238H34.36a.786.786 0 01-.56-.238.803.803 0 01-.229-.564v-.912h.741v.912c0 .013.006.025.012.031.012.012.024.018.036.018h3.565c.012 0 .024-.006.037-.018a.047.047 0 00.012-.03v-.913h.74zm5.143 0v.912a.81.81 0 01-.234.564.782.782 0 01-.554.238h-3.567a.771.771 0 01-.553-.238.81.81 0 01-.235-.564v-.912h.74v.912c0 .013.006.025.012.031h.006a.033.033 0 00.03.018h3.567a.033.033 0 00.03-.018c.012-.006.012-.018.012-.03v-.913h.746zM22.545 44.429v-.913a.047.047 0 00-.012-.03c-.006-.013-.018-.019-.036-.019h-3.565a.033.033 0 00-.03.019.034.034 0 00-.018.03v.913h-.741v-.913c0-.22.09-.422.235-.563a.762.762 0 01.554-.239h3.565c.223 0 .415.092.56.24a.78.78 0 01.229.562v.913h-.741zm15.429 0v-.913a.047.047 0 00-.012-.03c-.013-.013-.025-.019-.037-.019H34.36c-.012 0-.024.006-.036.019a.047.047 0 00-.012.03v.913h-.74v-.913c0-.22.084-.422.228-.563a.786.786 0 01.56-.239h3.565a.803.803 0 01.79.802v.913h-.741z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#396182",
                    fillRule: "nonzero",
                    d: "M43.111 44.429v-.913c0-.012 0-.024-.012-.03a.033.033 0 00-.03-.019h-3.567a.033.033 0 00-.03.019.034.034 0 00-.018.03v.913h-.74v-.913c0-.22.09-.422.235-.563a.76.76 0 01.553-.239h3.567c.217 0 .41.092.554.24.144.14.234.342.234.562v.913h-.746zM45 25v2.122c0 .36-.153.686-.404.926a1.392 1.392 0 01-.966.38H18.935c-.375 0-.716-.146-.96-.38a1.277 1.277 0 01-.404-.926V25h.7v2.122a.62.62 0 00.198.452c.12.114.285.185.466.185H43.63c.188 0 .353-.07.472-.185a.644.644 0 00.199-.452V25H45zm-6.857 4v13.714h-.673V29h.673zm-3.429 13.714V29h.673v13.714h-.673zm8-13.714v13.714h-.672V29h.672zm-3.428 13.714V29h.672v13.714h-.672zm-22.549 2.857h29.097a.85.85 0 01.617.272h.006c.16.16.257.39.257.638v1.376H15.857v-1.376c0-.248.097-.473.257-.638a.873.873 0 01.623-.272zm29.097.727H16.737a.178.178 0 00-.125.053v.006a.163.163 0 00-.052.124v.65h29.451v-.65a.187.187 0 00-.051-.124v-.006a.19.19 0 00-.126-.053z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    fill: "#396182",
                    fillRule: "nonzero",
                    d: "M17 45.571v-.907c0-.221.097-.427.258-.57h.005a.897.897 0 01.618-.237H44.12c.24 0 .457.09.618.238.16.147.263.348.263.57v.906h-.71v-.907a.153.153 0 00-.046-.11l-.005-.006a.182.182 0 00-.12-.042H17.88a.176.176 0 00-.125.047.159.159 0 00-.052.111v.907H17z"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProjectIcon);


/***/ }),

/***/ 61404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CountBadge; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);






function CountBadge(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: {
            display: "inline-flex",
            alignItems: "center",
            fontFamily: "monospace",
            justifyContent: "center",
            minWidth: 26,
            width: 26,
            maxWidth: 26,
            minHeight: 26,
            maxHeight: 26,
            height: 26,
            marginLeft: 6,
            padding: 2,
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .innovatorBlue */ .LD,
            fontSize: 11,
            background: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .lightestBlue */ .I,
            borderRadius: "100%"
        }
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 32796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "au": function() { return /* binding */ NoResources; },
/* harmony export */   "mp": function() { return /* binding */ NoAwards; },
/* harmony export */   "o0": function() { return /* binding */ NoPosts; },
/* harmony export */   "pH": function() { return /* binding */ NoSharingPage; },
/* harmony export */   "s1": function() { return /* binding */ NoSaved; },
/* harmony export */   "ss": function() { return /* binding */ NoProducts; },
/* harmony export */   "vJ": function() { return /* binding */ NoNewsworthy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87169);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94614);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56262);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95576);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98973);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35150);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52126);
/* harmony import */ var _components_icons_MakersIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52105);
/* harmony import */ var _components_form_NewsworthyField__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78949);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90489);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69057);














function NoPosts(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            borderRadius: 4,
            background: "#fff",
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2),
            padding: 24
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
            css: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                maxWidth: 400,
                margin: "0 auto"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PostIcon, {
                    width: 60,
                    height: 60
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .text */ .fL,
                        fontWeight: 500,
                        fontSize: 16
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        defaultMessage: "Let's get started!",
                        id: "UumDyt"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                        fontSize: 14
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        defaultMessage: "What do you want to share with the innovator community?",
                        id: "WJ8VNE"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                    css: {
                        margin: 0,
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                        fontSize: 14
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        defaultMessage: "Post <strong>questions</strong>, <strong>resources</strong>, <strong>projects</strong> and <strong>more...</strong>",
                        id: "Wem5tL",
                        values: {
                            // eslint-disable-next-line
                            strong: function(text) {
                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("strong", {
                                    children: text
                                });
                            }
                        }
                    })
                })
            ]
        })
    }));
}
function NoSaved(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            borderRadius: 4,
            background: "#fff",
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2),
            padding: 24
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
            css: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                maxWidth: 400,
                margin: "0 auto"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(SavedIcon, {
                    width: 60,
                    height: 60
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .text */ .fL,
                        fontWeight: 500,
                        fontSize: 16
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        defaultMessage: "Save something",
                        id: "uOgvte"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                        fontSize: 14
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        defaultMessage: "Find an interesting post, project, product or resource? Click on the bookmark icon to save it here!",
                        id: "4kHjwv"
                    })
                })
            ]
        })
    }));
}
function NoNewsworthy(_param) {
    var onAddNewsworthy = _param.onAddNewsworthy, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "onAddNewsworthy"
    ]);
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(false), 2), isAdding = ref[0], toggle = ref[1];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            borderRadius: 4,
            background: "#fff",
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2)
        },
        "data-intercom-target": "Group Newsworthy"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
            css: {
                padding: 24
            },
            children: [
                isAdding && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_2__/* .Margin */ .Zt, {
                    mb: 12,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_form_NewsworthyField__WEBPACK_IMPORTED_MODULE_4__/* .NewsworthyInput */ .qB, {
                        placeholder: intl.formatMessage({
                            defaultMessage: "Add a news article link and press Enter... https://",
                            id: "hIt47Y"
                        }),
                        onChange: function(newsworthy) {
                            return onAddNewsworthy(newsworthy);
                        },
                        padding: 0
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        maxWidth: 400,
                        margin: "0 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NewsIcon, {
                            width: 60,
                            height: 60
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "12px 0 0 0",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .text */ .fL,
                                fontWeight: 500,
                                fontSize: 16
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Share Updates",
                                id: "fC4Ovd"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "12px 0 0 0",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Add news articles and other updates about your projects or organization.",
                                id: "UBM2pY"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            size: "small",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .innovatorBlue */ .LD,
                            theme: "secondary",
                            onClick: toggle,
                            css: {
                                margin: "12px 0 0 0",
                                minWidth: 150
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Share Article",
                                id: "/GyMKa"
                            })
                        })
                    ]
                })
            ]
        })
    }));
}
function NoSharingPage(_param) {
    var onStartSharing = _param.onStartSharing, isForMakers = _param.isForMakers, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "onStartSharing",
        "isForMakers"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            borderRadius: 4,
            background: "#fff",
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2)
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                css: {
                    fontSize: 12,
                    textTransform: "uppercase",
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                    fontWeight: 500,
                    padding: 16,
                    borderBottom: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2),
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        defaultMessage: "Sharing",
                        id: "XfKNCg"
                    }),
                    isForMakers && false && /*#__PURE__*/ 0
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                css: {
                    padding: 24
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        maxWidth: 400,
                        margin: "0 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(ShareIcon, {
                            width: 60,
                            height: 60
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "12px 0 0 0",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .text */ .fL,
                                fontWeight: 500,
                                fontSize: 16
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Activate your Share Page",
                                id: "uK/HJT"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "12px 0 0 0",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Enable sharing to create a customizable public page to showcase your projects and more!",
                                id: "qvQxto"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            size: "small",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .innovatorBlue */ .LD,
                            theme: "secondary",
                            onClick: onStartSharing,
                            css: {
                                margin: "12px 0 0 0",
                                minWidth: 150
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Start Sharing",
                                id: "WW+hXh"
                            })
                        })
                    ]
                })
            })
        ]
    }));
}
function NoResources(_param) {
    var onAddResource = _param.onAddResource, innerRef = _param.innerRef, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "onAddResource",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            borderRadius: 4,
            background: "#fff",
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2)
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                css: {
                    fontSize: 12,
                    textTransform: "uppercase",
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                    fontWeight: 500,
                    padding: 16,
                    borderBottom: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2)
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    defaultMessage: "Resources",
                    id: "c/KktL"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                css: {
                    padding: 24
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        maxWidth: 400,
                        margin: "0 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StackIcon, {
                            width: 60,
                            height: 60
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "12px 0 0 0",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .text */ .fL,
                                fontWeight: 500,
                                fontSize: 16
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Share Resources",
                                id: "HcaWQZ"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "12px 0 0 0",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Share useful resources like open source code, planning documents, etc.",
                                id: "FNn0A5"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                            ref: innerRef,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                size: "small",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .innovatorBlue */ .LD,
                                theme: "secondary",
                                onClick: onAddResource,
                                css: {
                                    margin: "12px 0 0 0",
                                    minWidth: 150
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    defaultMessage: "Add Resource",
                                    id: "A0sFkU"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
}
function NoAwards(_param) {
    var onAddAwards = _param.onAddAwards, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "onAddAwards"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            background: "#fff",
            borderRadius: 4,
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2)
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                css: {
                    padding: 16,
                    display: "flex",
                    borderBottom: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2)
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                    css: {
                        fontSize: 12,
                        fontWeight: 500,
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                        textTransform: "uppercase"
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        defaultMessage: "\uD83C\uDFC5 Awards",
                        id: "RT1ZpG"
                    })
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                css: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    maxWidth: 400,
                    margin: "0 auto",
                    padding: 24
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(AwardsIcon, {
                        width: 60,
                        height: 60
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                        css: {
                            margin: "12px 0 0 0",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .text */ .fL,
                            fontWeight: 500,
                            fontSize: 16
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            defaultMessage: "Add Awards",
                            id: "HldPvv"
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                        css: {
                            margin: "12px 0 0 0",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                            fontSize: 14
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            defaultMessage: "Share useful awards...",
                            id: "RSObAr"
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            size: "small",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .innovatorBlue */ .LD,
                            theme: "secondary",
                            onClick: onAddAwards,
                            css: {
                                margin: "12px 0 0 0",
                                minWidth: 150
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Add Awards",
                                id: "HldPvv"
                            })
                        })
                    })
                ]
            })
        ]
    }));
}
function NoProducts(_param) {
    var onAddProduct = _param.onAddProduct, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "onAddProduct"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            borderRadius: 4,
            background: "#fff",
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2)
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                css: {
                    fontSize: 12,
                    textTransform: "uppercase",
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                    fontWeight: 500,
                    padding: 16,
                    borderBottom: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2)
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    defaultMessage: "Products",
                    id: "7NFfmz"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                css: {
                    padding: 24
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        maxWidth: 400,
                        margin: "0 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(ResourceIcon, {
                            width: 60,
                            height: 60
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "12px 0 0 0",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .text */ .fL,
                                fontWeight: 500,
                                fontSize: 16
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Build your product stack",
                                id: "zbw64e"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: "12px 0 0 0",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Share what products and tools you're using to innovate your community.",
                                id: "0cTs7/"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            size: "small",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .innovatorBlue */ .LD,
                            theme: "secondary",
                            onClick: onAddProduct,
                            css: {
                                margin: "12px 0 0 0",
                                minWidth: 150
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                defaultMessage: "Add Tools",
                                id: "+yfT26"
                            })
                        })
                    ]
                })
            })
        ]
    }));
}
var ShareIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 62,
        height: 62,
        viewBox: "0 0 62 62"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#DAEAF6",
                    stroke: "#005AEE",
                    strokeWidth: 1.25,
                    d: "M30.8 1.2c16.367 0 29.629 13.261 29.629 29.621 0 16.368-13.262 29.629-29.63 29.629-16.36 0-29.62-13.261-29.62-29.629 0-16.36 13.26-29.621 29.62-29.621z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#EAEAEA",
                    fillRule: "nonzero",
                    d: "M17.03 39.66h-5.784V22.282h5.784z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M50.756 40.139H11.244V22.28h39.512"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M50.756 36.595H22.11V26.11h28.646m-30.762 5.242a2.969 2.969 0 01-2.964 2.976 2.969 2.969 0 01-2.963-2.976 2.969 2.969 0 012.963-2.976 2.969 2.969 0 012.964 2.976z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#2C426B",
                    fillRule: "nonzero",
                    d: "M25.175 28.34h.664v2.285h.015c.105-.189.27-.355.475-.468.197-.115.429-.19.678-.19.49 0 1.273.303 1.273 1.567v2.179h-.662v-2.105c0-.588-.22-1.09-.846-1.09-.429 0-.766.303-.887.668a.776.776 0 00-.046.317v2.21h-.664V28.34zm4.948.658v1.053h.949v.505h-.95v1.976c0 .455.129.71.497.71.174 0 .302-.022.387-.043l.028.499c-.128.053-.33.09-.587.09-.31 0-.557-.098-.716-.28-.188-.196-.257-.521-.257-.954v-1.998h-.564v-.505h.564v-.878l.649-.175zm2.492 0v1.053h.95v.505h-.95v1.976c0 .455.128.71.497.71.173 0 .301-.022.385-.043l.03.499c-.13.053-.331.09-.588.09-.309 0-.557-.098-.716-.28-.187-.196-.256-.521-.256-.954v-1.998h-.564v-.505h.564v-.878l.648-.175zm2.349 3.224a1.026 1.026 0 001.025 1.053c.7 0 1.108-.576 1.108-1.416 0-.734-.384-1.362-1.085-1.362-.452 0-.874.324-1.002.825a1.107 1.107 0 00-.046.272v.628zm-.656-.977c0-.468-.014-.846-.03-1.194h.596l.03.628h.014c.272-.448.703-.712 1.297-.712.882 0 1.544.75 1.544 1.862 0 1.316-.799 1.968-1.657 1.968-.481 0-.905-.213-1.123-.576h-.015v1.99h-.656v-3.966zm4.195 1.787c.196.13.543.264.874.264.482 0 .707-.241.707-.543 0-.32-.187-.494-.678-.674-.654-.235-.964-.598-.964-1.037 0-.591.476-1.075 1.26-1.075.368 0 .692.105.896.227l-.167.485a1.404 1.404 0 00-.747-.214c-.39 0-.61.229-.61.5 0 .304.22.44.695.621.633.243.955.56.955 1.106 0 .642-.496 1.097-1.362 1.097-.4 0-.77-.1-1.025-.251l.166-.506zm3.203.983l2.102-5.486h.513l-2.11 5.486zm2.582 0l2.102-5.486h.513l-2.11 5.486z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#005AEE",
                    fillRule: "nonzero",
                    d: "M25.966 38.869l-1.445 1.85-3.537-3.655-2.05 2.135L17 31.714l7.376 1.83-1.913 1.991c1.104 1.151 2.398 2.184 3.503 3.334z"
                })
            ]
        })
    }));
};
var ResourceIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 61,
        height: 61,
        viewBox: "0 0 61 61"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#DAEAF6",
                    stroke: "#005AEE",
                    strokeWidth: 0.714,
                    d: "M30.8 1.2c16.367 0 29.629 13.261 29.629 29.621 0 16.368-13.262 29.629-29.63 29.629-16.36 0-29.62-13.261-29.62-29.629 0-16.36 13.26-29.621 29.62-29.621z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#EAEAEA",
                    fillRule: "nonzero",
                    d: "M29.32 39.983V18.14H27.3v26.585h8.08v-1.951h-3.245c-1.554 0-2.815-1.25-2.815-2.79zm-10.014 0V18.14h-2.02v26.585h8.079v-1.951H22.12c-1.555 0-2.814-1.25-2.814-2.79z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#0091FC",
                    fillRule: "nonzero",
                    d: "M25.365 26.742h-8.08V23.42h8.08z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#0770BF",
                    fillRule: "nonzero",
                    d: "M35.38 26.742H27.3V23.42h8.08z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.143,
                    d: "M17.286 31.755V18.14h8.079v26.585h-8.079V37.77m0-14.351h8.079m-8.079 3.323h4.04m2.561 0h1.478"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.143,
                    d: "M23.493 39.92c0 1.186-.97 2.149-2.168 2.149a2.16 2.16 0 01-2.167-2.15 2.16 2.16 0 012.167-2.15 2.16 2.16 0 012.168 2.15zm11.887 4.805H27.3V18.14h8.08zM27.3 23.419h8.08m-8.08 3.323h4.04"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.143,
                    d: "M33.508 39.92c0 1.186-.97 2.149-2.167 2.149a2.16 2.16 0 01-2.169-2.15 2.16 2.16 0 012.169-2.15 2.16 2.16 0 012.167 2.15zm.398-13.178h1.474"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#EAEAEA",
                    fillRule: "nonzero",
                    d: "M39.797 39.974V18.132h-2.02v26.585h8.08v-1.951h-3.245c-1.555 0-2.815-1.25-2.815-2.792z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#B0DDFC",
                    fillRule: "nonzero",
                    d: "M45.857 26.733h-8.08V23.41h8.08z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.143,
                    d: "M45.857 44.717h-8.08V18.132h8.08zm-8.08-21.307h8.08m-8.08 3.323h4.04"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.143,
                    d: "M43.985 39.91a2.16 2.16 0 01-2.168 2.15 2.16 2.16 0 01-2.168-2.15c0-1.186.97-2.15 2.168-2.15a2.16 2.16 0 012.168 2.15zm.398-13.177h1.473"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    d: "M16.143 16h29.714v29.714H16.143z"
                })
            ]
        })
    }));
};
function AwardsIcon(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 100,
        height: 100,
        viewBox: "0 0 100 100"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("circle", {
                    stroke: "#005AEE",
                    strokeWidth: 1.177,
                    fill: "#DAEAF6",
                    cx: 49.808,
                    cy: 49.808,
                    r: 48.954
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            d: "M57.742 42.416a8.88 8.88 0 01-8.882 8.882 8.879 8.879 0 01-8.88-8.882 8.878 8.878 0 018.88-8.88 8.88 8.88 0 018.882 8.88z",
                            fill: "#0091FC",
                            fillRule: "nonzero"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            fill: "#EAEAEA",
                            fillRule: "nonzero",
                            d: "M29.141 66.375l-5.297 7.062 11.894-2.636 6.19 11.282 1.333-8.96-4.833-8.805zM69.892 64.643l6.263 6.223-12.151-.89-4.496 12.061-2.613-8.673 3.511-9.415z"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            d: "M51.535 26.1h0a3.367 3.367 0 003.514.94 3.367 3.367 0 014.31 2.49 3.365 3.365 0 002.573 2.571 3.368 3.368 0 012.488 4.313 3.366 3.366 0 00.943 3.511 3.37 3.37 0 010 4.982 3.366 3.366 0 00-.943 3.511 3.367 3.367 0 01-2.488 4.314 3.367 3.367 0 00-2.572 2.57 3.365 3.365 0 01-4.311 2.489 3.376 3.376 0 00-3.514.941 3.364 3.364 0 01-4.98 0 3.371 3.371 0 00-3.51-.941 3.366 3.366 0 01-4.313-2.49 3.367 3.367 0 00-2.57-2.57 3.37 3.37 0 01-2.493-4.313 3.364 3.364 0 00-.939-3.51 3.37 3.37 0 010-4.983 3.364 3.364 0 00.939-3.51A3.37 3.37 0 0136.16 32.1a3.366 3.366 0 002.57-2.57 3.368 3.368 0 014.314-2.49 3.362 3.362 0 003.51-.941 3.369 3.369 0 014.98 0z",
                            stroke: "#2C426B",
                            strokeWidth: 2,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            d: "M55.553 36.578c-2.311-2.715-5.32-3.041-6.508-3.041a8.879 8.879 0 00-8.88 8.879 8.88 8.88 0 008.88 8.882 8.88 8.88 0 008.882-8.882M37.683 54.988l-13.84 18.448L35.739 70.8l6.193 11.285 2.61-20.108M59.36 55.301L76.156 71.11l-12.174-.562-4.167 12.177-6.502-19.019",
                            stroke: "#2C426B",
                            strokeWidth: 2,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            ]
        })
    }));
}
var NewsIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 61,
        height: 61
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#DAEAF6",
                    stroke: "#005AEE",
                    strokeWidth: 0.721,
                    d: "M30.585 1.199C46.835 1.199 60 14.368 60 30.614c0 16.255-13.165 29.424-29.415 29.424-16.242 0-29.408-13.17-29.408-29.424C1.177 14.368 14.343 1.2 30.585 1.2z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#0770BF",
                    fillRule: "nonzero",
                    d: "M18.733 43.65H15.52v-3.204h3.213z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#0091FC",
                    fillRule: "nonzero",
                    d: "M38.336 43.65H18.733v-3.204h19.603z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#EAEAEA",
                    fillRule: "nonzero",
                    d: "M18.733 40.446H15.52V17.65h3.213z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#B0DDFC",
                    fillRule: "nonzero",
                    d: "M41.55 43.65h-3.214v-3.204h3.214z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.154,
                    d: "M41.55 27.056V43.65H15.466v-26H41.55v6.21"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#2C426B",
                    fillRule: "nonzero",
                    d: "M23.78 26.255h-1.15l-1.702-2.98v2.98h-1.16v-4.787h1.16l1.698 2.978v-2.978h1.155zm3.712-2.032h-1.82v1.145h2.15v.887h-3.309v-4.787h3.315v.89h-2.156v1.01h1.82zm4.523.246l.55-3.001h1.148l-1.02 4.786h-1.2l-.643-2.728-.63 2.728h-1.198L28 21.468h1.151l.55 3 .66-3h.983zm4.627.513c0-.17-.06-.3-.179-.394-.12-.094-.33-.192-.632-.292a5.991 5.991 0 01-.739-.294c-.623-.304-.934-.723-.934-1.256 0-.265.078-.499.233-.702.155-.203.375-.36.658-.473.284-.114.602-.169.956-.169.345 0 .656.061.93.184.273.123.485.297.637.524.152.227.227.486.227.778h-1.154c0-.195-.06-.346-.18-.455-.119-.107-.281-.16-.486-.16-.207 0-.37.045-.49.136a.421.421 0 00-.18.348c0 .122.066.233.198.332.133.1.365.203.697.31.332.107.604.221.817.344.52.298.778.709.778 1.232 0 .418-.158.748-.474.987-.316.239-.751.359-1.303.359a2.58 2.58 0 01-1.057-.21c-.316-.139-.554-.33-.712-.571a1.49 1.49 0 01-.24-.838h1.161c0 .258.067.446.2.568.133.121.348.183.648.183.192 0 .342-.042.453-.124a.407.407 0 00.167-.347z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.154,
                    d: "M17.906 29.808H39.11m0 2.619H17.908m-.002 2.619h8.257m0 3.18h-8.257m21.204 0h-9.194m0-3.18h9.194m4.334 4.578l.015-10.221a.939.939 0 01.94-.932h.195a.94.94 0 01.94.937V40.78a2.82 2.82 0 01-2.82 2.81H41.55"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    d: "M14.899 15.328h31.202V46.54H14.899z"
                })
            ]
        })
    }));
};
var StackIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 61,
        height: 62,
        viewBox: "0 0 62 62"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#DAEAF6",
                    stroke: "#005AEE",
                    strokeWidth: 1.25,
                    d: "M30.3 1.45c16.367 0 29.629 13.261 29.629 29.621 0 16.368-13.262 29.629-29.63 29.629C13.94 60.7.68 47.439.68 31.071.68 14.711 13.94 1.45 30.3 1.45z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#EAEAEA",
                    fillRule: "nonzero",
                    d: "M18.431 32.7H15.96v13.248h13.247v-2.32h-6.275a4.5 4.5 0 01-4.5-4.5V32.7z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M28.896 42.284v3.664H15.648V32.7h13.248v4.086"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#EAEAEA",
                    fillRule: "nonzero",
                    d: "M34.724 32.7h-2.471v13.248H45.5v-2.32h-6.275a4.5 4.5 0 01-4.501-4.5V32.7z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M45.188 42.284v3.664H31.941V32.7h13.247v4.086"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#EAEAEA",
                    fillRule: "nonzero",
                    d: "M26.591 16.7H24.12v13.25h13.248v-2.32h-6.275a4.5 4.5 0 01-4.5-4.5V16.7z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M37.056 26.285v3.664H23.808V16.7h13.248v4.085"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#0091FC",
                    fillRule: "nonzero",
                    d: "M29.8 24.39h1.56l-.783-2.52-.778 2.52zm1.98 1.35h-2.4l-.419 1.36h-1.87l2.664-7.266H31.4l2.684 7.265h-1.88l-.426-1.358zm10.438 14.468a2.642 2.642 0 01-.409 1.339c-.25.387-.6.687-1.05.9-.45.214-.966.32-1.544.32-.955 0-1.706-.311-2.256-.933-.548-.622-.822-1.5-.822-2.634v-.36c0-.712.122-1.335.37-1.87a2.825 2.825 0 011.07-1.236c.467-.29 1.005-.436 1.618-.436.882 0 1.589.232 2.125.695.536.465.84 1.104.913 1.919h-1.746c-.013-.442-.125-.76-.334-.953-.21-.192-.53-.289-.958-.289-.436 0-.755.162-.958.489-.203.326-.31.847-.32 1.563v.512c0 .776.097 1.33.292 1.661.194.334.53.5 1.006.5.402 0 .71-.095.922-.284.214-.19.327-.491.34-.903h1.741zm-20.853-.629v1.741h1.147c.317 0 .559-.073.73-.218.169-.144.253-.347.253-.61 0-.606-.3-.91-.903-.913h-1.227zm0-1.148h.912c.383-.003.655-.073.82-.21.162-.136.244-.339.244-.606 0-.307-.09-.529-.265-.663-.176-.134-.46-.202-.853-.202h-.858v1.681zm-1.751 4.236v-7.264h2.609c.934 0 1.645.172 2.133.514.487.342.73.84.73 1.49 0 .378-.085.698-.258.964a1.526 1.526 0 01-.764.589c.379.1.671.287.873.558.203.273.304.606.304 1 0 .712-.225 1.246-.675 1.602-.451.359-1.12.54-2.004.547h-2.948z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    d: "M14.5 15.25h31v31h-31z"
                })
            ]
        })
    }));
};
var SavedIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 100,
        height: 100,
        viewBox: "0 0 100 100"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("circle", {
                    cx: 49.808,
                    cy: 49.808,
                    r: 48.954,
                    fill: "#DAEAF6",
                    stroke: "#005AEE",
                    strokeWidth: 1.177
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#EAEAEA",
                    fillRule: "nonzero",
                    d: "M23.533 51.054h6.073v19.198h-6.073z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#0091FC",
                    fillRule: "nonzero",
                    d: "M69.082 51.67H23.364v-7.61h18.078l3.632 3.633h24.008z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#0770BF",
                    fillRule: "nonzero",
                    d: "M23.742 44.077h5.864v7.573h-5.864z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    fill: "#B0DDFC",
                    fillRule: "nonzero",
                    d: "M61.988 48.227h6.622v3.443h-6.622z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.834,
                    d: "M56.37 70.336H23.28V43.374h16.892l4.059 4.061h24.851v9.731M29.125 38.177l4.55-13.644 32.483 9.746-1.95 9.096M36.923 31.03l23.39 6.822m-25.015 0l22.741 5.524"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    stroke: "#2C426B",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.834,
                    d: "M75.635 68.314a7.663 7.663 0 11-15.325.001 7.663 7.663 0 0115.325 0zm-7.661-4.412v8.967m4.482-4.483H63.49"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                    d: "M16.765 17.563H82.15v65.384H16.765z"
                })
            ]
        })
    }));
};
var PostIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 100,
        height: 100,
        viewBox: "0 0 100 100"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("circle", {
                    cx: 49.808,
                    cy: 49.808,
                    r: 48.954,
                    fill: "#DAEAF6",
                    stroke: "#005AEE",
                    strokeWidth: 1.177
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("g", {
                    transform: "translate(29 28)",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            stroke: "#2C426B",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M19.06 44.17H.016V.657h38.306v17.817"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            fill: "#EBEBEB",
                            fillRule: "nonzero",
                            d: "M23.958 36.798l-2.895 2.071.415 1.727 5.873 5.873 6.448-.17 5.15-5.15c-1.08.142-2.11-.435-3.11.558l-1.908 2.025c-.5.496-1.18.777-1.887.774l-3.42-.014a1.389 1.389 0 01-.97-.4l-3.641-3.89a1.98 1.98 0 01-.374-2.31l.319-1.094z"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            stroke: "#0091FC",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M23.863 36.704s-4.885 2.092-2.094 4.185c1.398 1.398 2.789 2.77 4.147 4.206 1.648 1.74 2.268 1.411 4.507 1.377 1.293-.02 2.608-.003 3.903-.003m11.164-11.16c-2.512-4.143-5.301-7.674-8.48-11.314-1.412-1.618-2.286-2.2-4.446-1.527-2.809.94-6.063 3.8-8.168 5.869l-.485.479m3.422 11.357l-3.489-3.49m11.182 1.415l-4.885-4.884m8.373 1.396l-4.886-4.883"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            stroke: "#0091FC",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M40.609 39.925l-6.414 6.414 3.271 3.27 5.349-5.348 3.488-3.487 2.325-2.328-3.269-3.27-2.057 2.056m-19.439-.528l-7.835-8.264a2.665 2.665 0 010-3.754 2.664 2.664 0 013.754 0l4.128 4.13M6.006 16.31V6.435h2.47a2.476 2.476 0 012.468 2.47 2.477 2.477 0 01-2.468 2.468h-2.47"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("rect", {
                            width: 4.808,
                            height: 9.571,
                            x: 13.748,
                            y: 6.434,
                            stroke: "#0091FC",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            rx: 2.404
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                            stroke: "#0091FC",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M26.273 8.892a2.465 2.465 0 00-2.457-2.458c-2.223 0-3.323 2.891-1.588 4.325 1.169.968 2.822.167 3.74 1.87.888 1.648-.256 3.585-2.152 3.633a2.464 2.464 0 01-2.458-2.457m10.573-7.371V16m-2.853-9.566h5.707"
                        })
                    ]
                })
            ]
        })
    }));
};


/***/ }),

/***/ 37897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewLinkTab; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95576);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _components_mediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92418);
/* harmony import */ var _components_profile_CountBadge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61404);









function NewLinkTab(_param) {
    var href = _param.href, as = _param.as, title = _param.title, active = _param.active, count = _param.count, dataIntercomTarget = _param.dataIntercomTarget, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "href",
        "as",
        "title",
        "active",
        "count",
        "dataIntercomTarget"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
        href: href,
        as: as,
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            "data-intercom-target": dataIntercomTarget,
            css: (0,_components_mediaQueries__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                padding: [
                    0,
                    0,
                    10,
                    15
                ],
                minHeight: [
                    0,
                    0,
                    55,
                    65
                ],
                marginLeft: [
                    !!count && count > 0 ? 30 : 0,
                    0,
                    0,
                    0
                ],
                display: "flex",
                alignItems: "center",
                color: active ? _govlaunch_palette__WEBPACK_IMPORTED_MODULE_8__/* .innovatorBlue */ .LD : _govlaunch_palette__WEBPACK_IMPORTED_MODULE_8__/* .darkGray */ .O5,
                fontWeight: active ? 600 : "normal",
                fontSize: 16
            })
        }, props), {
            children: [
                title,
                " ",
                !!count && count > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_profile_CountBadge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    children: count
                })
            ]
        }))
    });
};


/***/ }),

/***/ 88925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NoProjectsBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _components_icons_ProjectIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20302);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95576);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98973);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67459);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69057);











function NoProjectsBox(_param) {
    var onAddProject = _param.onAddProject, dataIntercomTarget = _param.dataIntercomTarget, addButtonIntercomTarget = _param.addButtonIntercomTarget, title = _param.title, text = _param.text, buttonText = _param.buttonText, groupId = _param.groupId, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "onAddProject",
        "dataIntercomTarget",
        "addButtonIntercomTarget",
        "title",
        "text",
        "buttonText",
        "groupId"
    ]);
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var titleOrIntl = title || intl.formatMessage({
        defaultMessage: "Share your projects",
        id: "k0Ak8L"
    });
    var textOrIntl = text || intl.formatMessage({
        defaultMessage: "Share what you’re working on with your peers – or even your community. Adding a project takes less than a minute!",
        id: "iLbFZD"
    });
    var buttonTextOrIntl = buttonText || intl.formatMessage({
        defaultMessage: "Add Project",
        id: "BAZtPp"
    });
    if (isMobile) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(NoProjectBoxMobile, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            dataIntercomTarget: dataIntercomTarget,
            addButtonIntercomTarget: addButtonIntercomTarget,
            title: titleOrIntl,
            text: textOrIntl,
            buttonText: buttonTextOrIntl,
            groupId: groupId
        }, props));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(NoProjectBoxContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        onAddProject: onAddProject,
        dataIntercomTarget: dataIntercomTarget,
        addButtonIntercomTarget: addButtonIntercomTarget,
        title: titleOrIntl,
        text: textOrIntl,
        buttonText: buttonTextOrIntl,
        groupId: groupId
    }, props));
};
function NoProjectBoxContent(_param) {
    var onAddProject = _param.onAddProject, dataIntercomTarget = _param.dataIntercomTarget, addButtonIntercomTarget = _param.addButtonIntercomTarget, title = _param.title, text = _param.text, buttonText = _param.buttonText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "onAddProject",
        "dataIntercomTarget",
        "addButtonIntercomTarget",
        "title",
        "text",
        "buttonText"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        css: {
            borderRadius: 4,
            background: "#fff",
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .lightestGray */ .v2),
            padding: 24
        },
        "data-intercom-target": dataIntercomTarget
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
            css: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                maxWidth: 400,
                margin: "0 auto"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_icons_ProjectIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    width: 60,
                    height: 60
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .text */ .fL,
                        fontWeight: 500,
                        fontSize: 16
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .darkGray */ .O5,
                        fontSize: 14
                    },
                    children: text
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                    "data-intercom-target": addButtonIntercomTarget,
                    size: "small",
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_10__/* .innovatorBlue */ .LD,
                    theme: "secondary",
                    onClick: onAddProject,
                    css: {
                        margin: "12px 0 0 0",
                        minWidth: 150
                    },
                    children: buttonText
                })
            ]
        })
    }));
}
function NoProjectBoxMobile(_param) {
    var dataIntercomTarget = _param.dataIntercomTarget, addButtonIntercomTarget = _param.addButtonIntercomTarget, title = _param.title, text = _param.text, buttonText = _param.buttonText, groupId = _param.groupId, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "dataIntercomTarget",
        "addButtonIntercomTarget",
        "title",
        "text",
        "buttonText",
        "groupId"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        href: "/projects/create?groupId=".concat(groupId),
        as: "/projects/create",
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(NoProjectBoxContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            dataIntercomTarget: dataIntercomTarget,
            addButtonIntercomTarget: addButtonIntercomTarget,
            title: title,
            text: text,
            buttonText: buttonText
        }, props))
    });
}


/***/ }),

/***/ 81558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProfileNavbar; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95576);
/* harmony import */ var _components_mediaQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92418);




function ProfileNavbar(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        css: (0,_components_mediaQueries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            borderRadius: 5,
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_3__/* .white */ .ix,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_3__/* .lightestGray */ .v2),
            padding: [
                8,
                8,
                0,
                0
            ]
        }),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
            css: (0,_components_mediaQueries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                display: "flex",
                flexDirection: [
                    "column",
                    "column",
                    "row",
                    "row"
                ],
                flexWrap: "wrap",
                textAlign: "center",
                marginRight: 0,
                alignItems: [
                    "center",
                    "center",
                    "flex-start",
                    "flex-start"
                ],
                "& > :not(:last-of-type)": {
                    marginBottom: [
                        8,
                        8,
                        0,
                        0
                    ]
                }
            }),
            children: children
        })
    });
};


/***/ }),

/***/ 40243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64434);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = (algoliasearch__WEBPACK_IMPORTED_MODULE_0___default()("EKEGGUH63H", "MTYxNmZmYzhhMTFkNjI2NjcwZDFhZTM0ZmRmYjliY2U2MTQ3ZGJjMDgxY2M4YWE1ODA0YTJjZDQ5OTkyZmUwM3ZhbGlkVW50aWw9NDcyOTQyNjk1NQ=="));


/***/ }),

/***/ 31617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getIndexName; }
/* harmony export */ });
function getIndexName(index) {
    return "".concat(index, "_").concat("production");
};


/***/ }),

/***/ 90731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49980);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var downshift__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27242);
/* harmony import */ var react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13206);
/* harmony import */ var react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39274);
/* harmony import */ var react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23935);
/* harmony import */ var react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6988);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69057);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84380);
/* harmony import */ var _components_search_utils_algoliaClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40243);
/* harmony import */ var _components_search_utils_getIndexName__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31617);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52126);













function parseFacetFilters(type) {
    if (!type) {
        return [
            []
        ];
    }
    var includedTypes = null;
    if (!Array.isArray(type)) {
        includedTypes = [
            "types:".concat(type)
        ];
    }
    if (Array.isArray(type) && type.length > 0) {
        includedTypes = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(type.map(function(value) {
            return "types:".concat(value);
        }));
    }
    return [
        includedTypes
    ];
}
var TagsSelectContainer = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        indexName: (0,_components_search_utils_getIndexName__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("tags"),
        searchClient: _components_search_utils_algoliaClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ConnectedTagsSelect, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props))
    });
};
var TagsSelect = function(param) {
    var tags = param.hits, placeholder = param.placeholder, value = param.value, onFocus = param.onFocus, onBlur = param.onBlur, type = param.type, onChange = param.onChange;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var inputRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), inputValue = ref[0], setInputValue = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var selectableTags = skipTags(value, tags).slice(0, 5);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SearchBox, {
                defaultRefinement: inputValue
            }),
            type && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                facetFilters: parseFacetFilters(type)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(downshift__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                id: "tags-input-memo",
                selectedItem: null,
                inputValue: inputValue,
                itemToString: function(item) {
                    return (item === null || item === void 0 ? void 0 : item._id) || "";
                },
                stateReducer: function(_, changes) {
                    switch(changes.type){
                        case downshift__WEBPACK_IMPORTED_MODULE_11__/* ["default"].stateChangeTypes.changeInput */ .ZP.stateChangeTypes.changeInput:
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, changes), {
                                highlightedIndex: null
                            });
                        case downshift__WEBPACK_IMPORTED_MODULE_11__/* ["default"].stateChangeTypes.keyDownEnter */ .ZP.stateChangeTypes.keyDownEnter:
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, changes), {
                                isOpen: true,
                                highlightedIndex: 0
                            });
                        case downshift__WEBPACK_IMPORTED_MODULE_11__/* ["default"].stateChangeTypes.clickItem */ .ZP.stateChangeTypes.clickItem:
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, changes), {
                                isOpen: true,
                                highlightedIndex: 0
                            });
                    }
                    return changes;
                },
                onChange: function(selectedTag) {
                    setInputValue("");
                    onChange((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(value).concat([
                        selectedTag
                    ]));
                },
                onInputValueChange: function(value, changes) {
                    if (changes.type === downshift__WEBPACK_IMPORTED_MODULE_11__/* ["default"].stateChangeTypes.changeInput */ .ZP.stateChangeTypes.changeInput) {
                        setInputValue(value);
                    }
                },
                children: function(param) {
                    var getInputProps = param.getInputProps, getItemProps = param.getItemProps, getMenuProps = param.getMenuProps, highlightedIndex = param.highlightedIndex, isOpen = param.isOpen, openMenu = param.openMenu;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                                onClick: function() {
                                    if (inputRef.current) {
                                        inputRef.current.focus();
                                    }
                                },
                                css: {
                                    display: "flex",
                                    alignItems: "center",
                                    minHeight: 42,
                                    padding: 5,
                                    border: "solid 1px ".concat(isFocused ? _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__/* .primary */ .T$ : _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__/* .lightestGray */ .v2),
                                    borderRadius: 5,
                                    cursor: "text"
                                },
                                "data-intercom-target": "Project Tags Field",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                                    css: {
                                        display: "flex",
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        width: "100%"
                                    },
                                    children: [
                                        value.map(function(tag) {
                                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Tag, {
                                                children: tag.name
                                            }, tag.objectID || tag._id);
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, getInputProps({
                                            ref: inputRef,
                                            onFocus: function(event) {
                                                setIsFocused(true);
                                                if (onFocus) {
                                                    onFocus(event);
                                                }
                                                openMenu();
                                            },
                                            onBlur: function(event) {
                                                setIsFocused(false);
                                                if (onBlur) {
                                                    onBlur(event);
                                                }
                                            },
                                            onKeyDown: function(event) {
                                                if (event.key === "Backspace" && !event.target.value) {
                                                    onChange((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(value.slice(0, -1)));
                                                } else if (event.key === "Enter") {
                                                    event.preventDefault();
                                                }
                                            }
                                        })), {
                                            placeholder: placeholder || intl.formatMessage({
                                                defaultMessage: "Type to select tags...",
                                                id: "af49E1"
                                            }),
                                            css: {
                                                flexGrow: 1,
                                                margin: 5,
                                                fontSize: 14,
                                                border: 0,
                                                outline: 0,
                                                "&::placeholder": {
                                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__/* .sealBlue */ .N9,
                                                    fontSize: 14
                                                }
                                            }
                                        }))
                                    ]
                                })
                            }),
                            isOpen && selectableTags.length > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_3__/* .Margin */ .Zt, {
                                mt: 10,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, getMenuProps()), {
                                    css: {
                                        display: "flex",
                                        flexWrap: "wrap",
                                        marginLeft: -5
                                    },
                                    children: selectableTags.map(function(tag, index) {
                                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_spring__WEBPACK_IMPORTED_MODULE_1__.Spring, {
                                            config: {
                                                duration: 50
                                            },
                                            from: {
                                                transform: "scale(1)"
                                            },
                                            to: {
                                                transform: highlightedIndex === index ? "scale(1.05)" : "scale(1)"
                                            },
                                            children: function(style) {
                                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SelectableTag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, getItemProps({
                                                    item: tag,
                                                    index: index
                                                })), {
                                                    style: style,
                                                    css: {
                                                        backgroundColor: highlightedIndex === index ? _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__/* .lightBlue */ .f7 : null,
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__/* .lightestBlue */ .I
                                                        }
                                                    },
                                                    children: tag.name
                                                }));
                                            }
                                        }, tag.objectID || tag._id);
                                    })
                                }))
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var SelectableTag = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        css: {
            margin: 5,
            padding: "5px 10px",
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__/* .darkGray */ .O5,
            fontSize: 12,
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__/* .lightestGray */ .v2,
            borderRadius: 10
        }
    }));
};
var Tag = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        css: {
            margin: 5,
            padding: "5px 5px",
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_13__/* .darkGray */ .O5,
            fontSize: 12,
            backgroundColor: "rgba(219, 236, 247, 0.5)",
            borderRadius: 10
        }
    }));
};
function skipTags(tagsToSkip, tags) {
    var idsToSkip = tagsToSkip.map(function(param) {
        var objectID = param.objectID, _id = param._id;
        return objectID || _id;
    });
    return tags.filter(function(tag) {
        return !idsToSkip.includes(tag.objectID || tag._id);
    });
}
var SearchBox = (0,react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
    return null;
});
var ConnectedTagsSelect = (0,react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(TagsSelect);
/* harmony default export */ __webpack_exports__["Z"] = (TagsSelectContainer);


/***/ }),

/***/ 81177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mutations_ToggleFollow; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./lib/mutations/getTargetType.ts
var getTargetType = __webpack_require__(42293);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./lib/mutations/ToggleFollowMutation.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ToggleFollow($targetType: FollowType!, $targetId: ObjectId!) {\n    toggleFollow(targetType: $targetType, targetId: $targetId) {\n      __typename\n      ... on Government {\n        _id\n        isFollowing\n      }\n      ... on VendorUser {\n        _id\n        isFollowing\n      }\n      ... on GovernmentUser {\n        _id\n        isFollowing\n      }\n      ... on PendingUser {\n        _id\n        isFollowing\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ToggleFollowMutation = ((0,lib/* gql */.Ps)(_templateObject()));

// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./lib/apollo/RefetchQueriesFixLink.ts
var RefetchQueriesFixLink = __webpack_require__(69086);
;// CONCATENATED MODULE: ./lib/mutations/ToggleFollow.tsx







var ToggleFollow = function(param) {
    var entityType = param.entityType, targetId = param.targetId, viewerIsFollowing = param.viewerIsFollowing, children = param.children;
    var user = (0,Auth/* useSelfie */.yD)();
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: ToggleFollowMutation,
        variables: {
            targetType: (0,getTargetType/* default */.Z)(entityType),
            targetId: targetId
        },
        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
            "GetProfile"
        ]),
        children: function(toggleFollow) {
            return children({
                toggle: function() {
                    toggleFollow({
                        optimisticResponse: {
                            __typename: "Mutation",
                            toggleFollow: {
                                __typename: entityType,
                                _id: targetId,
                                isFollowing: !viewerIsFollowing
                            }
                        }
                    });
                }
            });
        }
    });
};
/* harmony default export */ var mutations_ToggleFollow = (ToggleFollow);


/***/ }),

/***/ 42293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTargetType; }
/* harmony export */ });
function getTargetType(entityType) {
    if ([
        "VendorUser",
        "GovernmentUser",
        "PendingUser"
    ].includes(entityType)) {
        return "USER";
    } else if (entityType === "Company") {
        return "COMPANY";
    } else if (entityType === "Government") {
        return "GOVERNMENT";
    } else {
        // should never happen... but ¯\_(ツ)_/¯
        throw new Error("Invalid entityType provided");
    }
};


/***/ }),

/***/ 76896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ConnectQuery; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
// EXTERNAL MODULE: ./lib/queries/fragments/GroupProjectFields.ts
var GroupProjectFields = __webpack_require__(94070);
// EXTERNAL MODULE: ./lib/queries/fragments/GovernmentProjectFields.ts
var GovernmentProjectFields = __webpack_require__(42046);
// EXTERNAL MODULE: ./lib/queries/fragments/VendorProjectFields.ts
var VendorProjectFields = __webpack_require__(4511);
;// CONCATENATED MODULE: ./lib/queries/fragments/ConnectFields.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ConnectFields on ConnectItem {\n    _id\n    createdAt\n    target {\n      __typename\n      ... on GovernmentProject {\n        _id\n        ...GovernmentProjectFields\n      }\n      ... on GroupProject {\n        _id\n        ...GroupProjectFields\n      }\n      ... on VendorProject {\n        _id\n        ...VendorProjectFields\n      }\n\n      ... on Government {\n        _id\n        name\n        slug\n        logo\n      }\n\n      ... on Company {\n        _id\n        name\n        slug\n        logo\n      }\n\n      ... on Story {\n        _id\n        slug\n        title\n        introduction\n        viewerCanRead\n        viewerDidUpvote\n        viewerDidBookmark\n        viewerDidComment\n        viewerIsAuthor\n        viewerIsCollaborator\n        commentsCount\n        upvotesCount\n        verticalCover\n        updatedAt\n        author {\n          ... on GovernmentUser {\n            _id\n            slug\n            email\n            fullName\n            avatar\n            jobTitle\n            isSelfie\n            isSiteAdmin\n            isLimitedSiteAdmin\n            government {\n              _id\n              slug\n              name\n              logo\n              city {\n                _id\n                country\n                countryName\n              }\n            }\n          }\n          ... on VendorUser {\n            _id\n            slug\n            email\n            isSelfie\n            isSiteAdmin\n            isLimitedSiteAdmin\n            fullName\n            avatar\n            jobTitle\n            company {\n              _id\n              slug\n              name\n              logo\n            }\n          }\n          ... on PendingUser {\n            _id\n            email\n            slug\n            avatar\n            fullName\n            isSiteAdmin\n            isLimitedSiteAdmin\n          }\n        }\n        storyGovernment: government {\n          _id\n          name\n          slug\n          logo\n          isInnovator\n          state\n          city {\n            _id\n            country\n            countryName\n          }\n        }\n        createdAt\n      }\n      ... on GovernmentUser {\n        _id\n        isSelfie\n        isSiteAdmin\n        isLimitedSiteAdmin\n        slug\n        avatar\n        fullName\n        isFollowing\n        government {\n          _id\n          slug\n          logo\n          name\n          isFollowing\n          city {\n            _id\n            country\n            countryName\n          }\n        }\n      }\n      ... on VendorUser {\n        _id\n        isSelfie\n        isSiteAdmin\n        isLimitedSiteAdmin\n        slug\n        avatar\n        fullName\n        isFollowing\n      }\n      ... on PendingUser {\n        _id\n        isSelfie\n        isSiteAdmin\n        isLimitedSiteAdmin\n        slug\n        avatar\n        fullName\n        isFollowing\n      }\n      ... on GovernmentPost {\n        _id\n        body\n        viewerCanEdit\n        created: createdAt\n        featuredAt\n        viewerCanDelete\n        viewerIsAuthor\n        postAudience: audience\n        upvotesCount\n        commentsCount\n        viewerDidBookmark\n        viewerDidUpvote\n        viewerDidComment\n\n        postAuthor: author {\n          ... on GovernmentUser {\n            _id\n            slug\n            fullName\n            firstName\n            avatar\n            jobTitle\n            email\n            government {\n              _id\n              name\n              logo\n              slug\n              city {\n                _id\n                country\n                countryName\n              }\n            }\n          }\n          ... on VendorUser {\n            _id\n            slug\n            fullName\n            firstName\n            avatar\n            email\n            jobTitle\n            company {\n              _id\n              name\n              logo\n              slug\n            }\n          }\n          ... on PendingUser {\n            _id\n            slug\n            email\n            fullName\n            firstName\n            avatar\n            jobTitle\n          }\n        }\n        postAttachments: attachments {\n          mimeType\n          filename\n          sizeInBytes\n          url\n        }\n        postLinks: links {\n          addedAt\n          description\n          title\n          favicon\n          siteName\n          url\n        }\n        postGovernment: government {\n          _id\n          slug\n          name\n          logo\n          city {\n            _id\n            country\n            countryName\n          }\n        }\n      }\n\n      ... on VendorPost {\n        _id\n        body\n        viewerCanEdit\n        created: createdAt\n        featuredAt\n        viewerCanDelete\n        viewerIsAuthor\n        postAudience: audience\n        upvotesCount\n        commentsCount\n        viewerDidBookmark\n        viewerDidUpvote\n        viewerDidComment\n\n        postAuthor: author {\n          ... on GovernmentUser {\n            _id\n            slug\n            fullName\n            firstName\n            avatar\n            jobTitle\n            email\n            government {\n              _id\n              name\n              logo\n              slug\n              city {\n                _id\n                country\n                countryName\n              }\n            }\n          }\n          ... on VendorUser {\n            _id\n            slug\n            fullName\n            firstName\n            avatar\n            email\n            jobTitle\n            company {\n              _id\n              name\n              logo\n              slug\n            }\n          }\n          ... on PendingUser {\n            _id\n            slug\n            email\n            fullName\n            firstName\n            avatar\n            jobTitle\n          }\n        }\n        postAttachments: attachments {\n          mimeType\n          filename\n          sizeInBytes\n          url\n        }\n        postLinks: links {\n          addedAt\n          description\n          title\n          favicon\n          siteName\n          url\n        }\n        postVendor: vendor {\n          _id\n          slug\n          name\n          logo\n        }\n      }\n\n      ... on GroupPost {\n        _id\n        body\n        viewerCanEdit\n        viewerCanDelete\n        created: createdAt\n        featuredAt\n        upvotesCount\n        commentsCount\n        viewerDidBookmark\n        viewerDidUpvote\n        viewerDidComment\n        viewerCanEdit\n        viewerIsAuthor\n        postAudience: audience\n        postGroup: group {\n          _id\n          name\n          slug\n          logo\n        }\n        postAuthor: author {\n          ... on GovernmentUser {\n            _id\n            slug\n            fullName\n            firstName\n            avatar\n            email\n            jobTitle\n            government {\n              _id\n              name\n              logo\n              slug\n              city {\n                _id\n                country\n                countryName\n              }\n            }\n          }\n          ... on VendorUser {\n            _id\n            slug\n            fullName\n            firstName\n            avatar\n            jobTitle\n            email\n            company {\n              _id\n              name\n              logo\n              slug\n            }\n          }\n          ... on PendingUser {\n            _id\n            slug\n            email\n            fullName\n            firstName\n            avatar\n            jobTitle\n          }\n        }\n        postAttachments: attachments {\n          mimeType\n          filename\n          sizeInBytes\n          url\n        }\n        postLinks: links {\n          addedAt\n          description\n          title\n          favicon\n          siteName\n          url\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ var ConnectFields = ((0,lib/* gql */.Ps)(_templateObject(), GroupProjectFields/* default */.Z, GovernmentProjectFields/* default */.Z, VendorProjectFields/* default */.Z));

;// CONCATENATED MODULE: ./lib/queries/ConnectQuery.ts

function ConnectQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Connect(\n    $targetId: ObjectId\n    $targetType: ConnectTargetType\n    $limit: Int!\n    $beforeThisId: ObjectId\n    $excludeUser: ObjectId\n  ) {\n    connect(\n      targetId: $targetId\n      targetType: $targetType\n      limit: $limit\n      beforeThisId: $beforeThisId\n      excludeUser: $excludeUser\n    ) {\n      totalCount\n      items {\n        __typename\n        _id\n        ...ConnectFields\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    ConnectQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var ConnectQuery = ((0,lib/* gql */.Ps)(ConnectQuery_templateObject(), ConnectFields));


/***/ })

}]);